(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-anuncio"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarMarquee(barra) {
    var pista = barra.querySelector('.ba-pista');
    var grupo = barra.querySelector('.ba-grupo');
    if (!pista || !grupo) {
      return;
    }
    if (grupo.scrollWidth === 0) {
      return;
    }

    var guarda = 0;
    while (pista.scrollWidth < barra.clientWidth * 2 + grupo.scrollWidth && guarda < 24) {
      pista.appendChild(grupo.cloneNode(true));
      guarda++;
    }

    var setW = grupo.scrollWidth;
    var vel = parseFloat(barra.getAttribute('data-velocidad')) || 70;
    var dir = barra.getAttribute('data-direccion') === 'derecha' ? 1 : -1;
    var x = dir === 1 ? -setW : 0;
    var pausado = false;
    var ultimo = null;

    if (barra.getAttribute('data-pausar-hover') === 'true') {
      barra.addEventListener('mouseenter', function () { pausado = true; });
      barra.addEventListener('mouseleave', function () { pausado = false; });
    }

    function animar(ts) {
      if (ultimo === null) { ultimo = ts; }
      var dt = (ts - ultimo) / 1000;
      ultimo = ts;
      if (!pausado) {
        x += dir * vel * dt;
        if (dir === -1 && x <= -setW) { x += setW; }
        if (dir === 1 && x >= 0) { x -= setW; }
        pista.style.transform = 'translateX(' + x + 'px)';
      }
      window.requestAnimationFrame(animar);
    }
    window.requestAnimationFrame(animar);
  }

  function iniciarOffset(barra) {
    var cabecera = null;
    function resolver() {
      if (!cabecera) {
        cabecera = document.querySelector('.gyh-cabecera--fija');
      }
      return cabecera;
    }
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var h = barra.offsetHeight;
      document.documentElement.style.setProperty('--ba-altura-barra', h + 'px');
      var c = resolver();
      if (c) {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        c.style.setProperty('top', Math.max(0, h - y) + 'px', 'important');
      }
    }
    function alScroll() {
      if (!pendiente) {
        pendiente = true;
        window.requestAnimationFrame(actualizar);
      }
    }
    actualizar();
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', actualizar);
    window.addEventListener('load', actualizar);
    if ('ResizeObserver' in window) {
      new ResizeObserver(actualizar).observe(barra);
    }
  }

  function iniciar(barra) {
    if (barra.dataset.baIniciado === 'true') {
      return;
    }
    barra.dataset.baIniciado = 'true';
    iniciarMarquee(barra);
    iniciarOffset(barra);
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-barra-anuncio]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.colIniciado === 'true') {
      return;
    }
    seccion.dataset.colIniciado = 'true';

    var cards = seccion.querySelectorAll('[data-col-card]');

    function mostrar() {
      cards.forEach(function (card, i) {
        setTimeout(function () {
          card.classList.add('col-card--visible');
        }, Math.min(i, 12) * 70);
      });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas, observador) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            mostrar();
            observador.disconnect();
          }
        });
      }, { threshold: 0.05 });
      obs.observe(seccion);
    } else {
      mostrar();
    }

    var orden = seccion.querySelector('[data-col-orden]');
    if (orden) {
      orden.addEventListener('change', function () {
        if (orden.form) {
          orden.form.submit();
        }
      });
    }

    seccion.querySelectorAll('[data-col-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        form.classList.add('col-cargando');
        setTimeout(function () {
          form.classList.remove('col-cargando');
        }, 1400);
      });
    });
  }

  function iniciarTodo() {
    document.querySelectorAll('.col-seccion').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comprapor-coleccion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(sec) {
    if (sec.dataset.ccInit === 'true') { return; }
    sec.dataset.ccInit = 'true';

    var pista = sec.querySelector('[data-cc-pista]');
    if (!pista) { return; }

    var cards = sec.querySelectorAll('[data-cc-card]');
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducido || !('IntersectionObserver' in window)) { return; }

    cards.forEach(function (c, i) {
      c.style.setProperty('opacity', '0', 'important');
      c.style.setProperty('transform', 'translateY(24px)', 'important');
    });

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        var i = Array.prototype.indexOf.call(cards, e.target);
        setTimeout(function () {
          e.target.style.removeProperty('opacity');
          e.target.style.removeProperty('transform');
        }, i * 90);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.15 });

    cards.forEach(function (c) { obs.observe(c); });
  }

  function todo() { document.querySelectorAll('.cc').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(sec) {
    if (sec.dataset.hsInit === 'true') { return; }
    sec.dataset.hsInit = 'true';

    var media = sec.querySelector('[data-hs-media]');
    var puntos = sec.querySelectorAll('[data-hs-punto]');
    if (!media || !puntos.length) { return; }

    var conPuntero = window.matchMedia('(hover: hover)').matches;
    var abierto = null;

    function cerrar() {
      puntos.forEach(function (p) { p.classList.remove('hs__punto--activo'); });
      media.classList.remove('hs__media--activo');
      abierto = null;
    }

    function abrir(punto) {
      puntos.forEach(function (p) { p.classList.remove('hs__punto--activo'); });
      punto.classList.add('hs__punto--activo');
      media.classList.add('hs__media--activo');
      abierto = punto;
    }

    puntos.forEach(function (punto) {
      var dot = punto.querySelector('[data-hs-dot]');
      var tarjeta = punto.querySelector('[data-hs-tarjeta]');
      if (!dot) { return; }

      if (conPuntero) {
        punto.addEventListener('mouseenter', function () { abrir(punto); });
        punto.addEventListener('mouseleave', function () { cerrar(); });
        dot.addEventListener('focus', function () { abrir(punto); });
        punto.addEventListener('focusout', function (e) {
          if (!punto.contains(e.relatedTarget)) { cerrar(); }
        });
      }

      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (abierto === punto) { cerrar(); } else { abrir(punto); }
      });

      if (tarjeta) {
        tarjeta.addEventListener('click', function (e) { e.stopPropagation(); });
      }
    });

    document.addEventListener('click', function (e) {
      if (abierto && !sec.contains(e.target)) { cerrar(); }
    });
    media.addEventListener('click', function (e) {
      if (abierto && e.target === media) { cerrar(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); }
    });
  }

  function todo() { document.querySelectorAll('.hs').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-billeteras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.billeteraIniciado) return;
    window.billeteraIniciado = true;

    var seccion = document.querySelector('.billetera-seccion');
    if (!seccion) return;

    var inputId = seccion.querySelector('[data-input-id]');
    var inputQty = seccion.querySelector('[data-input-qty]');
    var carrusel = seccion.querySelector('[data-carrusel]');
    var coloresCont = seccion.querySelector('[data-colores]');
    var unidadesActuales = 1;

    function slides() { return carrusel ? carrusel.querySelectorAll('[data-slide]') : []; }

    function irAIndice(i) {
      if (!carrusel || i < 0) return;
      carrusel.scrollTo({ left: i * carrusel.clientWidth, behavior: 'smooth' });
    }

    function indiceDeColor(swatch) {
      var lista = slides();
      var mid = swatch.getAttribute('data-media-id');
      if (mid) { for (var i = 0; i < lista.length; i++) { if (lista[i].getAttribute('data-media-id') === mid) return i; } }
      var url = (swatch.getAttribute('data-imagen') || '').split('?')[0];
      if (url) { for (var j = 0; j < lista.length; j++) { if ((lista[j].getAttribute('data-media') || '').split('?')[0] === url) return j; } }
      return -1;
    }

    function slotEl(n) { return seccion.querySelector('.billetera-color-slot[data-color-slot="' + n + '"]'); }

    function seleccionarColor(swatch) {
      var cont = swatch.closest('.billetera-color-slot');
      var slot = swatch.getAttribute('data-slot') || '1';
      var ambito = cont || seccion;
      ambito.querySelectorAll('.billetera-swatch').forEach(function (s) { s.classList.remove('esta-activo'); });
      swatch.classList.add('esta-activo');
      if (cont) {
        cont.setAttribute('data-slot-id', swatch.getAttribute('data-id'));
        cont.setAttribute('data-slot-disp', swatch.getAttribute('data-disponible'));
        var nom = cont.querySelector('[data-slot-nombre]');
        if (nom) nom.textContent = swatch.getAttribute('data-nombre');
      }
      if (slot === '1') {
        if (inputId) inputId.value = swatch.getAttribute('data-id');
        irAIndice(indiceDeColor(swatch));
      }
      actualizarBotones();
    }

    function coloresSeleccionados() {
      var res = [];
      if (!coloresCont) { if (inputId && inputId.value) res.push({ id: inputId.value, disp: true }); return res; }
      for (var s = 1; s <= unidadesActuales; s++) {
        var el = slotEl(s);
        if (!el) continue;
        var id = el.getAttribute('data-slot-id');
        var disp = el.getAttribute('data-slot-disp') !== 'false';
        res.push({ id: id, disp: disp && !!id });
      }
      return res;
    }

    function actualizarBotones() {
      var cols = coloresSeleccionados();
      var ok = cols.length > 0 && cols.every(function (c) { return c.id && c.disp; });
      seccion.querySelectorAll('[data-comprar]').forEach(function (b) { if (ok) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled'); });
    }

    function initSlots() {
      if (!coloresCont) return;
      coloresCont.querySelectorAll('.billetera-color-slot').forEach(function (el) {
        var activo = el.querySelector('.billetera-swatch.esta-activo') || el.querySelector('.billetera-swatch:not(.esta-agotado)') || el.querySelector('.billetera-swatch');
        if (!activo) return;
        activo.classList.add('esta-activo');
        el.setAttribute('data-slot-id', activo.getAttribute('data-id'));
        el.setAttribute('data-slot-disp', activo.getAttribute('data-disponible'));
        var nom = el.querySelector('[data-slot-nombre]');
        if (nom) nom.textContent = activo.getAttribute('data-nombre');
      });
    }

    function aplicarUnidades(u) {
      unidadesActuales = u;
      if (inputQty) inputQty.value = u;
      var titMulti = seccion.querySelector('[data-multicolor-titulo]');
      if (titMulti) { if (u > 1) titMulti.removeAttribute('hidden'); else titMulti.setAttribute('hidden', 'hidden'); }
      if (!coloresCont) return;
      coloresCont.querySelectorAll('.billetera-color-slot').forEach(function (el) {
        var n = parseInt(el.getAttribute('data-color-slot'), 10);
        if (n <= u) el.removeAttribute('hidden'); else el.setAttribute('hidden', 'hidden');
        var label = el.querySelector('[data-slot-label]');
        if (label) { var base = label.getAttribute('data-base') || 'Color'; label.textContent = (u > 1) ? (base + ' ' + n) : base; }
      });
    }

    function seleccionarPack(pack) {
      seccion.querySelectorAll('[data-pack]').forEach(function (p) { p.classList.remove('esta-activo'); });
      pack.classList.add('esta-activo');
      aplicarUnidades(parseInt(pack.getAttribute('data-unidades'), 10) || 1);
      actualizarBotones();
    }

    var puntos = seccion.querySelectorAll('[data-puntos] .billetera-punto');
    if (carrusel && puntos.length) {
      carrusel.addEventListener('scroll', function () {
        var idx = Math.round(carrusel.scrollLeft / carrusel.clientWidth);
        puntos.forEach(function (p, i) { p.classList.toggle('esta-activo', i === idx); });
      }, { passive: true });
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { irAIndice(i); }); });
    }

    seccion.querySelectorAll('[data-flecha]').forEach(function (fl) {
      fl.addEventListener('click', function () {
        if (!carrusel) return;
        var dir = parseInt(fl.getAttribute('data-flecha'), 10) || 1;
        var actual = Math.round(carrusel.scrollLeft / carrusel.clientWidth);
        irAIndice(Math.max(0, Math.min(slides().length - 1, actual + dir)));
      });
    });

    seccion.addEventListener('click', function (e) {
      var swatch = e.target.closest('.billetera-swatch');
      if (swatch) { seleccionarColor(swatch); return; }
      var pack = e.target.closest('[data-pack]');
      if (pack) { seleccionarPack(pack); return; }
      var cod = e.target.closest('[data-cod]');
      if (cod) {
        e.preventDefault();
        var itemsCod = itemsDeSeleccion();
        if (!itemsCod) return;
        agregarYSeguir(itemsCod, seccion.getAttribute('data-cod-multi') || '/cart', cod);
        return;
      }
      var comprar = e.target.closest('[data-comprar]');
      if (comprar && !comprar.hasAttribute('disabled')) { e.preventDefault(); comprarAhora(comprar); }
    });

    function agregarYSeguir(items, destino, boton) {
      var textoEl = boton ? boton.querySelector('[data-comprar-texto]') : null;
      var orig = textoEl ? textoEl.textContent : '';
      if (textoEl) textoEl.textContent = 'Procesando...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { window.location.href = destino; })
        .catch(function () { if (textoEl) textoEl.textContent = orig; });
    }

    function itemsDeSeleccion() {
      if (!coloresCont) {
        if (!inputId || !inputId.value) return null;
        return [{ id: inputId.value, quantity: unidadesActuales }];
      }
      var cols = coloresSeleccionados();
      if (!cols.length || !cols.every(function (c) { return c.id && c.disp; })) return null;
      return cols.map(function (c) { return { id: c.id, quantity: 1 }; });
    }

    function comprarAhora(boton) {
      var items = itemsDeSeleccion();
      if (!items) return;
      var accion = seccion.getAttribute('data-accion-comprar');
      agregarYSeguir(items, accion === 'carrito' ? '/cart' : '/checkout', boton);
    }

    initSlots();
    var packActivo = seccion.querySelector('[data-pack].esta-activo') || seccion.querySelector('[data-pack]');
    aplicarUnidades(packActivo ? (parseInt(packActivo.getAttribute('data-unidades'), 10) || 1) : 1);
    actualizarBotones();

    function fmtFecha(d) { var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']; return d.getDate() + ' ' + meses[d.getMonth()]; }
    function sumarHabiles(dias) { var d = new Date(); var s = 0; while (s < dias) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) s++; } return d; }
    var dMin = parseInt(seccion.getAttribute('data-dias-min'), 10) || 2;
    var dMax = parseInt(seccion.getAttribute('data-dias-max'), 10) || 5;
    var fMin = sumarHabiles(dMin), fMax = sumarHabiles(dMax);
    var eMin = seccion.querySelector('[data-fecha-min]'); if (eMin) eMin.textContent = fmtFecha(fMin);
    var eMax = seccion.querySelector('[data-fecha-max]'); if (eMax) eMax.textContent = fmtFecha(fMax);
    var p1 = seccion.querySelector('[data-fecha-paso1]'); if (p1) p1.textContent = 'Hoy';
    var p2 = seccion.querySelector('[data-fecha-paso2]'); if (p2) p2.textContent = fmtFecha(sumarHabiles(1));
    var p3 = seccion.querySelector('[data-fecha-paso3]'); if (p3) p3.textContent = fmtFecha(fMin) + ' - ' + fmtFecha(fMax);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CLAVE = 'sn_recientes';

  function formatearDinero(centavos, formato) {
    formato = formato || '${{amount}}';
    var mk = /\{\{\s*(\w+)\s*\}\}/;
    function sep(n, p, m, d) {
      p = p == null ? 2 : p; m = m == null ? ',' : m; d = d == null ? '.' : d;
      if (isNaN(n) || n == null) { return '0'; }
      n = (n / 100).toFixed(p);
      var pp = n.split('.');
      return pp[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + m) + (pp[1] ? d + pp[1] : '');
    }
    var mm = formato.match(mk), val;
    switch (mm ? mm[1] : '') {
      case 'amount_no_decimals': val = sep(centavos, 0); break;
      case 'amount_with_comma_separator': val = sep(centavos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(centavos, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': val = sep(centavos, 0, ' ', ''); break;
      case 'amount_with_space_separator': val = sep(centavos, 2, ' ', ','); break;
      default: val = sep(centavos, 2);
    }
    return formato.replace(mk, val);
  }

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function miniatura(url, ancho) {
    if (!url) { return ''; }
    var u = String(url);
    if (u.indexOf('//') === 0) { u = 'https:' + u; }
    if (u.indexOf('cdn.shopify.com') === -1 && u.indexOf('/cdn/shop/') === -1) { return u; }
    if (u.indexOf('width=') !== -1) { return u; }
    u = u.split('?')[0];
    return u + '?width=' + ancho;
  }

  function leerRecientes() { try { return JSON.parse(localStorage.getItem(CLAVE)) || []; } catch (e) { return []; } }

  function iniciar(raiz) {
    if (raiz.dataset.maincInit === 'true') { return; }
    raiz.dataset.maincInit = 'true';

    var formato = raiz.getAttribute('data-formato-dinero') || '${{amount}}';
    var umbral = (parseInt(raiz.getAttribute('data-umbral'), 10) || 0) * 100;
    var maxSug = parseInt(raiz.getAttribute('data-max-sugeridos'), 10) || 4;

    var items = raiz.querySelector('[data-mainc-items]');
    var conteo = raiz.querySelector('[data-mainc-conteo]');
    var subtotal = raiz.querySelector('[data-mainc-subtotal]');
    var notaInc = raiz.querySelector('[data-mainc-nota-inc]');
    var notaCal = raiz.querySelector('[data-mainc-nota-cal]');
    var envio = raiz.querySelector('[data-mainc-envio]');
    var envioMsg = raiz.querySelector('[data-mainc-envio-msg]');
    var barra = raiz.querySelector('[data-mainc-barra]');
    var sugCont = raiz.querySelector('[data-mainc-sugeridos]');
    var sugPista = raiz.querySelector('[data-mainc-sug-pista]');
    var enCarrito = [];

    var fallback = [];
    var fbEl = raiz.querySelector('[data-mainc-fallback]');
    if (fbEl) { try { fallback = JSON.parse(fbEl.textContent) || []; } catch (e) {} }

    function pintarEnvio(total) {
      if (!envio) { return; }
      if (umbral <= 0) { envio.hidden = true; return; }
      envio.hidden = false;
      var pct = Math.min(100, Math.round(total / umbral * 100));
      if (barra) { barra.style.setProperty('width', pct + '%', 'important'); }
      if (total >= umbral) {
        envio.classList.add('mainc__envio--ok');
        envioMsg.innerHTML = 'Felicitaciones, tienes envío gratis</b>';
      } else {
        envio.classList.remove('mainc__envio--ok');
        envioMsg.innerHTML = 'Te faltan <b>' + formatearDinero(umbral - total, formato) + '</b> para el <envío gratis</b>';
      }
    }

    function pintarNota(total) {
      var libre = (umbral > 0 && total >= umbral);
      if (notaInc) { notaInc.hidden = !libre; }
      if (notaCal) { notaCal.hidden = libre; }
    }

    function pintarItems(cart) {
      enCarrito = cart.items.map(function (i) { return i.handle; });
      if (cart.item_count === 0) { window.location.reload(); return; }
      var html = '';
      cart.items.forEach(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_220x$1$2') : '';
        var variante = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="mainc__item-var">' + escapar(it.variant_title) + '</span>' : '';
        html += '<div class="mainc__item" data-key="' + it.key + '">' +
          '<a class="mainc__item-foto" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="mainc__item-cuerpo">' +
            '<a class="mainc__item-nom" href="' + it.url + '">' + escapar(it.product_title) + '</a>' + variante +
            '<button class="mainc__item-quitar" type="button" data-mainc-quitar="' + it.key + '">Quitar</button>' +
            '<div class="mainc__item-fila">' +
              '<span class="mainc__qty"><button type="button" data-mainc-cambiar="' + it.key + '" data-delta="-1" aria-label="Restar">\u2212</button><span>' + it.quantity + '</span><button type="button" data-mainc-cambiar="' + it.key + '" data-delta="1" aria-label="Sumar">+</button></span>' +
              '<span class="mainc__item-precio">' + formatearDinero(it.final_line_price, formato) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      if (items) { items.innerHTML = html; }
      if (conteo) { conteo.textContent = cart.item_count; }
      if (subtotal) { subtotal.textContent = formatearDinero(cart.total_price, formato); }
      pintarEnvio(cart.total_price);
      pintarNota(cart.total_price);
      pintarSugeridos();
    }

    function pintarSugeridos() {
      if (!sugCont || !sugPista) { return; }
      var lista = leerRecientes().concat(fallback);
      var vistos = {}, final = [];
      lista.forEach(function (p) {
        if (!p || !p.handle) { return; }
        if (vistos[p.handle]) { return; }
        if (enCarrito.indexOf(p.handle) !== -1) { return; }
        vistos[p.handle] = true;
        final.push(p);
      });
      final = final.slice(0, maxSug);
      if (!final.length) { sugCont.hidden = true; return; }
      sugCont.hidden = false;
      var html = '';
      final.forEach(function (p) {
        var img = miniatura(p.image, 400);
        html += '<div class="mainc__sug">' +
          '<a class="mainc__sug-foto" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="mainc__sug-nom" href="' + p.url + '">' + escapar(p.title) + '</a>' +
          '<span class="mainc__sug-precio">' + formatearDinero(p.price, formato) + '</span>' +
          '<button class="mainc__sug-add" type="button" data-mainc-add="' + p.id + '">Agregar</button>' +
        '</div>';
      });
      sugPista.innerHTML = html;
    }

    function refrescar() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(pintarItems).catch(function () {});
    }

    function cambiar(key, cantidad) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: cantidad }) })
        .then(function (r) { return r.json(); }).then(pintarItems).catch(function () {});
    }

    function agregar(id, boton) {
      if (boton) { boton.setAttribute('disabled', 'disabled'); boton.textContent = 'Agregando...'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function () { refrescar(); })
        .catch(function () { if (boton) { boton.removeAttribute('disabled'); boton.textContent = 'Agregar'; } });
    }

    raiz.addEventListener('click', function (e) {
      var cam = e.target.closest('[data-mainc-cambiar]');
      var qui = e.target.closest('[data-mainc-quitar]');
      var add = e.target.closest('[data-mainc-add]');
      if (cam) {
        var cont = cam.closest('.mainc__item');
        var actual = parseInt(cont.querySelector('.mainc__qty span').textContent, 10) || 1;
        cambiar(cam.getAttribute('data-mainc-cambiar'), actual + parseInt(cam.getAttribute('data-delta'), 10));
      } else if (qui) {
        cambiar(qui.getAttribute('data-mainc-quitar'), 0);
      } else if (add) {
        agregar(add.getAttribute('data-mainc-add'), add);
      }
    });

    var totalInicial = parseInt(raiz.getAttribute('data-total'), 10) || 0;
    pintarEnvio(totalInicial);
    pintarNota(totalInicial);
    var itemsIniciales = raiz.querySelectorAll('.mainc__item');
    for (var i = 0; i < itemsIniciales.length; i++) { enCarrito.push(itemsIniciales[i].getAttribute('data-handle') || ''); }
    pintarSugeridos();
  }

  function iniciarTodo() { document.querySelectorAll('[data-mainc]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', iniciarTodo); } else { iniciarTodo(); }
  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(sec) {
    if (sec.dataset.mvInit === 'true') { return; }
    sec.dataset.mvInit = 'true';

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = sec.querySelectorAll('[data-mv-card]');
    if (!cards.length) { return; }

    if (reducido || !('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('mv__card--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        var i = Array.prototype.indexOf.call(cards, e.target);
        setTimeout(function () { e.target.classList.add('mv__card--visible'); }, (i % 4) * 80);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    cards.forEach(function (c) { obs.observe(c); });
  }

  function todo() { document.querySelectorAll('.mv').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuevos-ingresos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(sec) {
    if (sec.dataset.niInit === 'true') { return; }
    sec.dataset.niInit = 'true';

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = sec.querySelectorAll('[data-ni-card]');
    if (!cards.length) { return; }

    if (reducido || !('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('ni__card--visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        var i = Array.prototype.indexOf.call(cards, e.target);
        setTimeout(function () { e.target.classList.add('ni__card--visible'); }, (i % 4) * 80);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    cards.forEach(function (c) { obs.observe(c); });
  }

  function todo() { document.querySelectorAll('.ni').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pagina-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatearDinero(centavos, formato) {
    formato = formato || '${{amount}}';
    var mk = /\{\{\s*(\w+)\s*\}\}/;
    function sep(n, p, m, d) {
      p = p == null ? 2 : p; m = m == null ? ',' : m; d = d == null ? '.' : d;
      if (isNaN(n) || n == null) { return '0'; }
      n = (n / 100).toFixed(p);
      var pp = n.split('.');
      return pp[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + m) + (pp[1] ? d + pp[1] : '');
    }
    var mm = formato.match(mk), val;
    switch (mm ? mm[1] : '') {
      case 'amount_no_decimals': val = sep(centavos, 0); break;
      case 'amount_with_comma_separator': val = sep(centavos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(centavos, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': val = sep(centavos, 0, ' ', ''); break;
      case 'amount_with_space_separator': val = sep(centavos, 2, ' ', ','); break;
      default: val = sep(centavos, 2);
    }
    return formato.replace(mk, val);
  }

  function iniciar(sec) {
    if (sec.dataset.pnInit === 'true') { return; }
    sec.dataset.pnInit = 'true';

    var formato = sec.getAttribute('data-formato-dinero') || '${{amount}}';

    /* ---- Galeria ---- */
    var slides = sec.querySelectorAll('[data-pn-slide]');
    var thumbs = sec.querySelectorAll('[data-pn-thumb]');
    var dots = sec.querySelectorAll('[data-pn-dot]');
    var total = slides.length;
    var idx = 0;

    function irA(n) {
      idx = (n + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('pn__slide--activo', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('pn__thumb--activo', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('pn__dot--activo', i === idx); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { irA(parseInt(t.getAttribute('data-pn-thumb'), 10)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { irA(parseInt(d.getAttribute('data-pn-dot'), 10)); }); });
    var prev = sec.querySelector('[data-pn-prev]');
    var next = sec.querySelector('[data-pn-next]');
    if (prev) { prev.addEventListener('click', function () { irA(idx - 1); }); }
    if (next) { next.addEventListener('click', function () { irA(idx + 1); }); }

    var principal = sec.querySelector('[data-pn-principal]');
    if (principal && total > 1) {
      var sx = null;
      principal.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (sx === null) { return; }
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { irA(dx < 0 ? idx + 1 : idx - 1); }
        sx = null;
      });
    }

    /* ---- Zoom al cursor (escritorio) ---- */
    if (window.matchMedia('(hover: hover)').matches) {
      sec.querySelectorAll('[data-pn-zoomable]').forEach(function (img) {
        var cont = img.closest('.pn__slide');
        if (!cont) { return; }
        cont.addEventListener('mousemove', function (e) {
          var r = cont.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(1.8)';
        });
        cont.addEventListener('mouseleave', function () { img.style.transform = ''; });
      });
    }

    /* ---- Personas viendo ---- */
    var viendo = sec.querySelector('[data-pn-viendo]');
    var viendoNum = sec.querySelector('[data-pn-viendo-num]');
    if (viendo && viendoNum) {
      var vMin = parseInt(sec.getAttribute('data-viendo-min'), 10) || 4;
      var vMax = parseInt(sec.getAttribute('data-viendo-max'), 10) || 14;
      if (vMax > 16) { vMax = 16; }
      if (vMin > vMax) { vMin = vMax; }
      var actual = vMin + Math.floor(Math.random() * (vMax - vMin + 1));
      viendoNum.textContent = actual;
      viendo.hidden = false;
      setInterval(function () {
        actual += (Math.random() < 0.5 ? -1 : 1);
        if (actual < vMin) { actual = vMin; }
        if (actual > vMax) { actual = vMax; }
        viendoNum.textContent = actual;
      }, 24000 + Math.floor(Math.random() * 14000));
    }

    /* ---- RESENAS MINI: rotacion ---- */
    var resnBox = sec.querySelector('[data-pn-resn-quotes]');
    if (resnBox) {
      var rqs = resnBox.querySelectorAll('.pn__resn-q');
      if (rqs.length > 1) {
        var ri = 0;
        setInterval(function () {
          rqs[ri].classList.remove('pn__resn-q--on');
          ri = (ri + 1) % rqs.length;
          rqs[ri].classList.add('pn__resn-q--on');
        }, 3500);
      }
    }

    /* ---- STICKY CTA MOVIL ---- */
    var stickyBar = sec.querySelector('[data-pn-sticky]');
    var stickyBuyBtn = sec.querySelector('[data-pn-sticky-buy]');
    if (stickyBar) {
      var comprarBtn = sec.querySelector('[data-pn-comprar]') || sec.querySelector('[data-pn-add]');
      if (comprarBtn && 'IntersectionObserver' in window) {
        var sio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { stickyBar.classList.remove('pn__sticky--on'); }
            else { stickyBar.classList.add('pn__sticky--on'); }
          });
        }, { rootMargin: '0px 0px -35% 0px' });
        sio.observe(comprarBtn);
      } else {
        window.addEventListener('scroll', function () {
          if (window.pageYOffset > 400) { stickyBar.classList.add('pn__sticky--on'); }
          else { stickyBar.classList.remove('pn__sticky--on'); }
        }, { passive: true });
      }
      if (stickyBuyBtn) {
        stickyBuyBtn.addEventListener('click', function () {
          var t = sec.querySelector('[data-pn-comprar]') || sec.querySelector('[data-pn-add]');
          if (!t) { return; }
          t.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { try { t.click(); } catch (e) {} }, 560);
        });
      }
    }

    /* ---- NOTIFICACION DE COMPRA: rotacion ---- */
    var noti = sec.querySelector('[data-pn-noti]');
    if (noti) {
      var rawNotis = '';
      var notiDatos = sec.querySelector('[data-pn-noti-datos]');
      if (notiDatos) { try { rawNotis = JSON.parse(notiDatos.textContent) || ''; } catch (e) {} }
      var listaNotis = [];
      String(rawNotis).split('\n').forEach(function (l) {
        var pz = l.split('|');
        if (pz[0] && pz[0].trim()) { listaNotis.push({ n: pz[0].trim(), c: (pz[1] || '').trim() }); }
      });
      var notiNombre = noti.querySelector('[data-pn-noti-nombre]');
      var notiResto = noti.querySelector('[data-pn-noti-resto]');
      var notiCerrar = noti.querySelector('[data-pn-noti-cerrar]');
      var notiCada = parseInt(noti.getAttribute('data-notis-cada'), 10) || 35;
      var notiCerrado = false;
      var notiOcultar = null;
      if (notiCerrar) {
        notiCerrar.addEventListener('click', function () {
          notiCerrado = true;
          noti.classList.remove('pn__noti--on');
        });
      }
      function notiMostrar() {
        if (notiCerrado || !listaNotis.length || !notiNombre || !notiResto) { return; }
        var it = listaNotis[Math.floor(Math.random() * listaNotis.length)];
        var mins = 2 + Math.floor(Math.random() * 56);
        notiNombre.textContent = it.n;
        notiResto.textContent = (it.c ? 'de ' + it.c + ' ' : '') + 'compr\u00f3 hace ' + mins + ' min';
        noti.classList.add('pn__noti--on');
        clearTimeout(notiOcultar);
        notiOcultar = setTimeout(function () { noti.classList.remove('pn__noti--on'); }, 5200);
      }
      if (listaNotis.length) {
        setTimeout(function () {
          notiMostrar();
          setInterval(notiMostrar, notiCada * 1000 + Math.floor(Math.random() * 9000));
        }, 7000);
      }
    }

    /* ---- Variantes ---- */
    var datos = sec.querySelector('[data-pn-variantes]');
    var variantes = [];
    if (datos) { try { variantes = JSON.parse(datos.textContent) || []; } catch (e) {} }
    var idInput = sec.querySelector('[data-pn-id]');
    var cantInput = sec.querySelector('[data-pn-cantidad]');
    var grupos = sec.querySelectorAll('.pn__opcion');
    var btnAdd = sec.querySelector('[data-pn-add]');
    var btnComprar = sec.querySelector('[data-pn-comprar]');
    var addTxt = sec.querySelector('[data-pn-add-txt]');

    function varianteActual() {
      var id = idInput ? parseInt(idInput.value, 10) : 0;
      for (var i = 0; i < variantes.length; i++) { if (variantes[i].id === id) { return variantes[i]; } }
      return variantes[0] || null;
    }

    function actualizarVariante() {
      var sel = [];
      grupos.forEach(function (g) {
        var a = g.querySelector('.pn__chip--activo');
        sel.push(a ? a.getAttribute('data-valor') : null);
      });
      var v = variantes.find(function (x) { return x.options.every(function (val, i) { return val === sel[i]; }); });
      if (!v) { return; }
      if (idInput) { idInput.value = v.id; }

      grupos.forEach(function (g, i) {
        var lbl = sec.querySelector('[data-pn-opcion-val="' + i + '"]');
        if (lbl && sel[i]) { lbl.textContent = sel[i]; }
      });

      var pr = sec.querySelector('[data-pn-precio]');
      if (pr) { pr.textContent = formatearDinero(v.price, formato); }

      /* Actualizar sticky price tambien */
      var sp = sec.querySelector('[data-pn-sticky-price]');
      if (sp) { sp.textContent = formatearDinero(v.price, formato); }

      var ant = sec.querySelector('[data-pn-precio-antes]');
      if (ant) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          ant.textContent = formatearDinero(v.compare_at_price, formato);
          ant.style.display = '';
        } else { ant.style.display = 'none'; }
      }

      var dis = !v.available;
      [btnComprar].forEach(function (b) {
        if (!b) { return; }
        if (dis) { b.setAttribute('disabled', 'disabled'); } else { b.removeAttribute('disabled'); }
      });
      if (btnAdd) {
        if (dis) { btnAdd.setAttribute('disabled', 'disabled'); btnAdd.classList.add('pn__add--agotado'); if (addTxt) { addTxt.textContent = btnAdd.getAttribute('data-agotado') || addTxt.textContent; } }
        else { btnAdd.removeAttribute('disabled'); btnAdd.classList.remove('pn__add--agotado'); }
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('.pn__chip').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.pn__chip').forEach(function (x) { x.classList.remove('pn__chip--activo'); });
          b.classList.add('pn__chip--activo');
          actualizarVariante();
        });
      });
    });

    /* ---- Cantidad ---- */
    sec.querySelectorAll('[data-pn-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cantInput) { return; }
        var val = parseInt(cantInput.value, 10) || 1;
        val += parseInt(b.getAttribute('data-pn-cant'), 10);
        if (val < 1) { val = 1; }
        cantInput.value = val;
      });
    });

    function cantidad() { return cantInput ? (parseInt(cantInput.value, 10) || 1) : 1; }

    /* ---- Agregar al carrito (abre cajon lateral) ---- */
    var form = sec.querySelector('#pn-form');
    if (form && btnAdd) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = varianteActual();
        if (!v || !v.available) { return; }
        btnAdd.setAttribute('disabled', 'disabled');
        var prevTxt = addTxt ? addTxt.textContent : '';
        if (addTxt) { addTxt.textContent = 'Agregando...'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: cantidad() })
        }).then(function (r) {
          if (!r.ok) { throw new Error('no'); }
          return r.json();
        }).then(function () {
          btnAdd.removeAttribute('disabled');
          if (addTxt) { addTxt.textContent = prevTxt; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var abrir = document.querySelector('[data-carrito-abrir]');
          if (abrir) { abrir.click(); } else { window.location.href = '/cart'; }
        }).catch(function () {
          btnAdd.removeAttribute('disabled');
          if (addTxt) { addTxt.textContent = prevTxt; }
        });
      });
    }

    /* ---- Comprar ahora: checkout directo ---- */
    if (btnComprar) {
      btnComprar.addEventListener('click', function () {
        var v = varianteActual();
        if (!v || !v.available) { return; }
        btnComprar.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: cantidad() })
        }).then(function (r) {
          if (!r.ok) { throw new Error('no'); }
          window.location.href = '/checkout';
        }).catch(function () { btnComprar.removeAttribute('disabled'); });
      });
    }

    /* ---- Acordeon (envios/cambios + descripcion) ---- */
    sec.querySelectorAll('[data-pn-acc]').forEach(function (item) {
      var cab = item.querySelector('[data-pn-acc-toggle]');
      var cuerpo = item.querySelector('[data-pn-acc-cuerpo]');
      if (!cab || !cuerpo) { return; }
      cab.addEventListener('click', function () {
        var abierto = cuerpo.classList.toggle('pn__acc-cuerpo--abierto');
        cab.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });

    /* ---- Entrega estimada: suma dias habiles a la fecha de hoy ---- */
    var entrega = sec.querySelector('[data-pn-entrega]');
    if (entrega) {
      var diasPaso = parseInt(sec.getAttribute('data-dias-paso'), 10) || 4;
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

      function sumarHabiles(base, dias) {
        var d = new Date(base.getTime());
        var sumados = 0;
        while (sumados < dias) {
          d.setDate(d.getDate() + 1);
          var dow = d.getDay();
          if (dow !== 0 && dow !== 6) { sumados += 1; }
        }
        return d;
      }
      function ddmmaaaa(d) {
        var dd = ('0' + d.getDate()).slice(-2);
        var mm = ('0' + (d.getMonth() + 1)).slice(-2);
        return dd + '/' + mm + '/' + d.getFullYear();
      }
      function cortita(d) {
        return meses[d.getMonth()] + ' ' + d.getDate();
      }

      var hoy = new Date();
      var fProceso = sumarHabiles(hoy, diasPaso);
      var fEntrega = sumarHabiles(hoy, diasPaso * 2);

      var elIni = sec.querySelector('[data-pn-fecha-ini]');
      var elFin = sec.querySelector('[data-pn-fecha-fin]');
      if (elIni) { elIni.textContent = ddmmaaaa(fProceso); }
      if (elFin) { elFin.textContent = ddmmaaaa(fEntrega); }

      var t1 = sec.querySelector('[data-pn-tl-1]');
      var t2 = sec.querySelector('[data-pn-tl-2]');
      var t3 = sec.querySelector('[data-pn-tl-3]');
      if (t1) { t1.textContent = cortita(hoy); }
      if (t2) { t2.textContent = cortita(hoy) + ' - ' + cortita(fProceso); }
      if (t3) { t3.textContent = cortita(fProceso) + ' - ' + cortita(fEntrega); }
    }

    /* ---- Vistos recientemente (localStorage sn_recientes del carrito) ---- */
    var recientes = sec.querySelector('[data-pn-recientes]');
    var grid = sec.querySelector('[data-pn-recientes-grid]');
    if (recientes && grid) {
      var actualEl = sec.querySelector('[data-pn-actual]');
      var handleActual = '';
      if (actualEl) { try { handleActual = (JSON.parse(actualEl.textContent) || {}).handle || ''; } catch (e) {} }

      var lista = [];
      try { lista = JSON.parse(localStorage.getItem('sn_recientes')) || []; } catch (e) {}
      lista = lista.filter(function (x) { return x && x.handle && x.handle !== handleActual; }).slice(0, 4);

      if (lista.length) {
        var html = '';
        lista.forEach(function (it) {
          var img = it.image || '';
          if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
          html += '<a class="pn__rec-card" href="' + it.url + '">' +
            '<span class="pn__rec-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="pn__rec-nom">' + (it.title || '') + '</span>' +
            '<span class="pn__rec-precio">' + formatearDinero(it.price, formato) + '</span>' +
            '</a>';
        });
        grid.innerHTML = html;
        recientes.hidden = false;
      }
    }
  }

  function todo() { document.querySelectorAll('.pn').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portada_street"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.portIniciado === 'true') {
      return;
    }
    seccion.dataset.portIniciado = 'true';

    var slides = seccion.querySelectorAll('.port-slide');
    var total = slides.length;
    if (total === 0) {
      return;
    }

    var numeros = seccion.querySelectorAll('.port-contador__num');
    var progreso = seccion.querySelector('.port-contador__progreso');
    var botonPausa = seccion.querySelector('.port-pausa');
    var botonScroll = seccion.querySelector('.port-scroll');

    var autoplay = seccion.getAttribute('data-autoplay') === 'true';
    var intervalo = parseInt(seccion.getAttribute('data-intervalo'), 10) || 6000;

    var indice = 0;
    var pausado = false;
    var inicio = null;
    var raf = null;

    function mostrar(i) {
      indice = (i + total) % total;
      slides.forEach(function (s, idx) {
        s.classList.toggle('port-slide--activo', idx === indice);
      });
      numeros.forEach(function (n, idx) {
        n.classList.toggle('port-contador__num--activo', idx === indice);
      });
      inicio = null;
      if (progreso) {
        progreso.style.width = '0%';
      }
    }

    function paso(ts) {
      if (autoplay && !pausado && total > 1) {
        if (inicio === null) {
          inicio = ts;
        }
        var t = (ts - inicio) / intervalo;
        if (t >= 1) {
          mostrar(indice + 1);
        } else if (progreso) {
          progreso.style.width = (t * 100) + '%';
        }
      }
      raf = window.requestAnimationFrame(paso);
    }

    numeros.forEach(function (n, idx) {
      n.addEventListener('click', function () {
        mostrar(idx);
      });
    });

    if (botonPausa) {
      botonPausa.addEventListener('click', function () {
        pausado = !pausado;
        seccion.classList.toggle('port-seccion--pausado', pausado);
        if (!pausado) {
          inicio = null;
        }
      });
    }

    if (botonScroll) {
      botonScroll.addEventListener('click', function () {
        var destino = seccion.getBoundingClientRect().bottom + window.pageYOffset;
        window.scrollTo({ top: destino, behavior: 'smooth' });
      });
    }

    mostrar(0);
    if (autoplay && total > 1) {
      raf = window.requestAnimationFrame(paso);
    }
  }

  function iniciarTodo() {
    document.querySelectorAll('.port-seccion').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["propuesta-valor"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.ivIniciado === 'true') {
      return;
    }
    seccion.dataset.ivIniciado = 'true';

    var items = seccion.querySelectorAll('[data-iv-item]');

    function mostrar() {
      items.forEach(function (item, i) {
        setTimeout(function () {
          item.classList.add('iv-item--visible');
        }, i * 120);
      });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas, observador) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            mostrar();
            observador.disconnect();
          }
        });
      }, { threshold: 0.2 });
      obs.observe(seccion);
    } else {
      mostrar();
    }
  }

  function iniciarTodo() {
    document.querySelectorAll('.iv-seccion').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-bolsos-mujer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.bolsosMujerIniciado) { return; }
  window.bolsosMujerIniciado = true;

  function iniciar(seccion) {
    if (seccion.dataset.bolsosInit === 'true') { return; }
    seccion.dataset.bolsosInit = 'true';

    var grid = seccion.querySelector('[data-grid]');
    if (!grid) { return; }

    var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    var chips = Array.prototype.slice.call(seccion.querySelectorAll('[data-chip]'));
    var selOrden = seccion.querySelector('[data-orden]');
    var btnMas = seccion.querySelector('[data-ver-mas]');
    var conteo = seccion.querySelector('[data-conteo]');
    var sinRes = seccion.querySelector('[data-sin-resultados]');
    var sticky = seccion.querySelector('[data-sticky]');
    var stickyItems = seccion.querySelector('[data-sticky-items]');
    var stickyTotal = seccion.querySelector('[data-sticky-total]');
    var toast = seccion.querySelector('[data-toast]');
    var ancla = seccion.querySelector('[data-grid-ancla]');

    var porPagina = parseInt(seccion.getAttribute('data-por-pagina'), 10) || 12;
    var visibles = porPagina;
    var tagActual = '';
    var ordenActual = 'destacados';
    var temporizadorToast = null;

    function formatoCOP(cents) {
      var n = Math.round((cents || 0) / 100);
      return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function mostrarToast(texto) {
      if (!toast) { return; }
      toast.textContent = texto;
      toast.removeAttribute('hidden');
      if (temporizadorToast) { clearTimeout(temporizadorToast); }
      temporizadorToast = setTimeout(function () { toast.setAttribute('hidden', 'hidden'); }, 2200);
    }

    function filtradas() {
      if (!tagActual) { return tarjetas.slice(); }
      return tarjetas.filter(function (c) {
        var t = (c.getAttribute('data-tags') || '');
        return t.split(',').some(function (x) { return x.trim() === tagActual; });
      });
    }

    function ordenar(lista) {
      var copia = lista.slice();
      if (ordenActual === 'precio-asc') {
        copia.sort(function (a, b) { return (parseInt(a.getAttribute('data-precio'), 10) || 0) - (parseInt(b.getAttribute('data-precio'), 10) || 0); });
      } else if (ordenActual === 'precio-desc') {
        copia.sort(function (a, b) { return (parseInt(b.getAttribute('data-precio'), 10) || 0) - (parseInt(a.getAttribute('data-precio'), 10) || 0); });
      } else {
        copia.sort(function (a, b) { return (parseInt(a.getAttribute('data-orden'), 10) || 0) - (parseInt(b.getAttribute('data-orden'), 10) || 0); });
      }
      return copia;
    }

    function pintar() {
      var lista = ordenar(filtradas());
      tarjetas.forEach(function (c) { c.setAttribute('hidden', 'hidden'); });
      lista.forEach(function (c, i) {
        grid.appendChild(c);
        if (i < visibles) { c.removeAttribute('hidden'); }
      });
      if (conteo) {
        var mostrando = Math.min(visibles, lista.length);
        conteo.textContent = lista.length ? ('Mostrando ' + mostrando + ' de ' + lista.length + ' bolsos') : '';
      }
      if (sinRes) {
        if (lista.length === 0) { sinRes.removeAttribute('hidden'); } else { sinRes.setAttribute('hidden', 'hidden'); }
      }
      if (btnMas) {
        if (lista.length > visibles) { btnMas.removeAttribute('hidden'); } else { btnMas.setAttribute('hidden', 'hidden'); }
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('esta-activo'); });
        chip.classList.add('esta-activo');
        tagActual = (chip.getAttribute('data-tag') || '').toLowerCase().trim();
        visibles = porPagina;
        pintar();
      });
    });

    if (selOrden) {
      selOrden.addEventListener('change', function () {
        ordenActual = selOrden.value;
        visibles = porPagina;
        pintar();
      });
    }

    if (btnMas) {
      btnMas.addEventListener('click', function () {
        visibles += porPagina;
        pintar();
      });
    }

    seccion.querySelectorAll('[data-ir-grid]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (ancla) { ancla.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    grid.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-sw]');
      if (sw) {
        var card = sw.closest('[data-card]');
        if (!card) { return; }
        card.querySelectorAll('[data-sw]').forEach(function (s) { s.classList.remove('esta-activo'); });
        sw.classList.add('esta-activo');
        card.setAttribute('data-variante', sw.getAttribute('data-id'));
        var img = sw.getAttribute('data-img');
        var principal = card.querySelector('[data-img-principal]');
        if (img && principal) { principal.src = img; }
        var ptxt = card.querySelector('[data-precio-txt]');
        if (ptxt && sw.getAttribute('data-precio-txt')) { ptxt.textContent = sw.getAttribute('data-precio-txt'); }
        return;
      }

      var add = e.target.closest('[data-add]');
      if (!add) { return; }
      e.preventDefault();
      var tarjeta = add.closest('[data-card]');
      if (!tarjeta) { return; }

      if (tarjeta.getAttribute('data-multi') === 'true') {
        window.location.href = tarjeta.getAttribute('data-url');
        return;
      }

      var swActivo = tarjeta.querySelector('[data-sw].esta-activo');
      if (swActivo && swActivo.getAttribute('data-disponible') === 'false') {
        mostrarToast('Ese color esta agotado');
        return;
      }

      var id = tarjeta.getAttribute('data-variante');
      if (!id) { window.location.href = tarjeta.getAttribute('data-url'); return; }

      var txt = add.querySelector('.bolsos-add__txt');
      var original = txt ? txt.textContent : '';
      if (txt) { txt.textContent = 'Agregando'; }
      add.classList.add('esta-listo');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function () {
          if (txt) { txt.textContent = 'Agregado'; }
          mostrarToast('Agregado al carrito');
          actualizarCarrito();
          setTimeout(function () {
            if (txt) { txt.textContent = original; }
            add.classList.remove('esta-listo');
          }, 1800);
        })
        .catch(function () {
          if (txt) { txt.textContent = original; }
          add.classList.remove('esta-listo');
          window.location.href = tarjeta.getAttribute('data-url');
        });
    });

    function actualizarCarrito() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!sticky) { return; }
          if (d.item_count > 0) {
            sticky.removeAttribute('hidden');
            if (stickyItems) { stickyItems.textContent = d.item_count === 1 ? '1 articulo' : (d.item_count + ' articulos'); }
            if (stickyTotal) { stickyTotal.textContent = formatoCOP(d.total_price); }
          } else {
            sticky.setAttribute('hidden', 'hidden');
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {});
    }

    pintar();
    actualizarCarrito();
  }

  function todo() { document.querySelectorAll('[data-bolsos]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-busuqeda-nueva"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.buscaNovaIniciado) { return; }
  window.buscaNovaIniciado = true;

  var CLAVE_RECIENTES = 'sn_busquedas_recientes';
  var CLAVE_VISTOS = 'sn_productos_vistos';

  function leer(clave) {
    try {
      var crudo = window.localStorage.getItem(clave);
      var datos = crudo ? JSON.parse(crudo) : [];
      return Array.isArray(datos) ? datos : [];
    } catch (e) { return []; }
  }

  function guardar(clave, datos) {
    try { window.localStorage.setItem(clave, JSON.stringify(datos)); } catch (e) {}
  }

  function escapar(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function limpiarMarcas(html) {
    var permitido = String(html == null ? '' : html);
    permitido = permitido.replace(/<(?!\/?mark\b)[^>]*>/gi, '');
    return permitido;
  }

  function iniciar(raiz) {
    if (raiz.dataset.buscaInit === 'true') { return; }
    raiz.dataset.buscaInit = 'true';

    var panel = raiz.querySelector('[data-panel]');
    var velo = raiz.querySelector('[data-velo]');
    var campo = raiz.querySelector('[data-campo]');
    var form = raiz.querySelector('[data-form]');
    var btnLimpiar = raiz.querySelector('[data-limpiar]');
    var cajaRecientes = raiz.querySelector('[data-recientes]');
    var chipsRecientes = raiz.querySelector('[data-chips-recientes]');
    var cajaSugerencias = raiz.querySelector('[data-caja-sugerencias]');
    var chipsSugerencias = raiz.querySelector('[data-chips-sugerencias]');
    var cajaVistos = raiz.querySelector('[data-vistos]');
    var filaVistos = raiz.querySelector('[data-fila-vistos]');
    var cajaResultados = raiz.querySelector('[data-caja-resultados]');
    var gridResultados = raiz.querySelector('[data-grid-resultados]');
    var tituloResultados = raiz.querySelector('[data-titulo-resultados]');
    var verTodo = raiz.querySelector('[data-ver-todo]');
    var cajaVacio = raiz.querySelector('[data-vacio]');
    var cargando = raiz.querySelector('[data-cargando]');

    var urlBusqueda = raiz.getAttribute('data-url-busqueda') || '/search';
    var urlPredictiva = raiz.getAttribute('data-url-predictiva') || '/search/suggest';
    var limite = parseInt(raiz.getAttribute('data-limite'), 10) || 8;
    var maxRecientes = parseInt(raiz.getAttribute('data-max-recientes'), 10) || 8;
    var sugerenciasBase = chipsSugerencias ? chipsSugerencias.innerHTML : '';
    var tituloBase = tituloResultados ? tituloResultados.textContent : 'Resultados';

    var temporizador = null;
    var controlador = null;
    var ultima = '';

    registrarVisto();

    function registrarVisto() {
      var h = raiz.getAttribute('data-ph');
      if (!h) { return; }
      var lista = leer(CLAVE_VISTOS).filter(function (p) { return p && p.h !== h; });
      lista.unshift({
        h: h,
        t: raiz.getAttribute('data-pt') || '',
        u: raiz.getAttribute('data-pu') || '',
        i: raiz.getAttribute('data-pi') || '',
        p: raiz.getAttribute('data-pp') || '',
        v: raiz.getAttribute('data-pv') || ''
      });
      guardar(CLAVE_VISTOS, lista.slice(0, 12));
    }

    function pintarRecientes() {
      if (!cajaRecientes || !chipsRecientes) { return; }
      var lista = leer(CLAVE_RECIENTES);
      if (!lista.length) { cajaRecientes.setAttribute('hidden', 'hidden'); return; }
      cajaRecientes.removeAttribute('hidden');
      chipsRecientes.innerHTML = lista.map(function (t) {
        return '<button type="button" class="busca-chip" data-reciente data-texto="' + escapar(t) + '">' + escapar(t) +
          '<span class="busca-chip__x" data-borrar-reciente><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></span></button>';
      }).join('');
    }

    function pintarVistos() {
      if (!cajaVistos || !filaVistos) { return; }
      var lista = leer(CLAVE_VISTOS).filter(function (p) { return p && p.u && p.i; });
      if (!lista.length) { cajaVistos.setAttribute('hidden', 'hidden'); return; }
      cajaVistos.removeAttribute('hidden');
      filaVistos.innerHTML = lista.slice(0, 10).map(function (p) {
        return '<a class="busca-visto" href="' + escapar(p.u) + '">' +
          '<img class="busca-visto__img" src="' + escapar(p.i) + '" alt="" loading="lazy">' +
          '<span class="busca-visto__t">' + escapar(p.t) + '</span>' +
          (p.p ? '<span class="busca-visto__p">' + escapar(p.p) + '</span>' : '') +
          '</a>';
      }).join('');
    }

    function guardarBusqueda(texto) {
      var t = (texto || '').trim();
      if (t.length < 2) { return; }
      var lista = leer(CLAVE_RECIENTES).filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
      lista.unshift(t);
      guardar(CLAVE_RECIENTES, lista.slice(0, maxRecientes));
      pintarRecientes();
    }

    function estadoInicial() {
      if (cajaResultados) { cajaResultados.setAttribute('hidden', 'hidden'); }
      if (cajaVacio) { cajaVacio.setAttribute('hidden', 'hidden'); }
      if (cargando) { cargando.setAttribute('hidden', 'hidden'); }
      if (chipsSugerencias) { chipsSugerencias.innerHTML = sugerenciasBase; }
      if (cajaSugerencias) {
        if (sugerenciasBase.trim()) { cajaSugerencias.removeAttribute('hidden'); } else { cajaSugerencias.setAttribute('hidden', 'hidden'); }
      }
      pintarRecientes();
      pintarVistos();
    }

    function abrir() {
      if (!panel || !velo) { return; }
      velo.removeAttribute('hidden');
      panel.removeAttribute('hidden');
      document.body.classList.add('busca-sin-scroll');
      window.requestAnimationFrame(function () {
        velo.classList.add('esta-visible');
        panel.classList.add('esta-abierto');
      });
      estadoInicial();
      setTimeout(function () { if (campo) { campo.focus(); } }, 180);
    }

    function cerrar() {
      if (!panel || !velo) { return; }
      panel.classList.remove('esta-abierto');
      velo.classList.remove('esta-visible');
      document.body.classList.remove('busca-sin-scroll');
      setTimeout(function () {
        panel.setAttribute('hidden', 'hidden');
        velo.setAttribute('hidden', 'hidden');
      }, 300);
    }

    var sel = raiz.getAttribute('data-abridores') || '[data-busca-abrir]';
    document.addEventListener('click', function (e) {
      var disparador = null;
      try { disparador = e.target.closest(sel); } catch (err) { disparador = e.target.closest('[data-busca-abrir]'); }
      if (!disparador) { return; }
      e.preventDefault();
      e.stopPropagation();
      abrir();
    }, true);

    raiz.querySelectorAll('[data-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    if (velo) { velo.addEventListener('click', cerrar); }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hasAttribute('hidden')) { cerrar(); }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var t = (campo.value || '').trim();
        if (!t) { e.preventDefault(); return; }
        guardarBusqueda(t);
      });
    }

    if (btnLimpiar) {
      btnLimpiar.addEventListener('click', function () {
        campo.value = '';
        btnLimpiar.setAttribute('hidden', 'hidden');
        ultima = '';
        estadoInicial();
        campo.focus();
      });
    }

    var limpiarRecientes = raiz.querySelector('[data-limpiar-recientes]');
    if (limpiarRecientes) {
      limpiarRecientes.addEventListener('click', function () {
        guardar(CLAVE_RECIENTES, []);
        pintarRecientes();
      });
    }

    raiz.addEventListener('click', function (e) {
      var borrar = e.target.closest('[data-borrar-reciente]');
      if (borrar) {
        e.preventDefault();
        e.stopPropagation();
        var chipB = borrar.closest('[data-reciente]');
        if (!chipB) { return; }
        var txt = chipB.getAttribute('data-texto') || '';
        var lista = leer(CLAVE_RECIENTES).filter(function (x) { return x !== txt; });
        guardar(CLAVE_RECIENTES, lista);
        pintarRecientes();
        return;
      }

      var chip = e.target.closest('[data-reciente], [data-sugerencia], [data-consulta]');
      if (!chip) { return; }
      var enlace = chip.getAttribute('data-enlace');
      var texto = chip.getAttribute('data-texto') || '';
      if (enlace) { guardarBusqueda(texto); window.location.href = enlace; return; }
      campo.value = texto;
      if (btnLimpiar) { btnLimpiar.removeAttribute('hidden'); }
      consultar(texto);
      campo.focus();
    });

    if (campo) {
      campo.addEventListener('input', function () {
        var t = campo.value.trim();
        if (btnLimpiar) {
          if (t) { btnLimpiar.removeAttribute('hidden'); } else { btnLimpiar.setAttribute('hidden', 'hidden'); }
        }
        if (temporizador) { clearTimeout(temporizador); }
        if (t.length < 2) { ultima = ''; estadoInicial(); return; }
        if (t === ultima) { return; }
        temporizador = setTimeout(function () { consultar(t); }, 220);
      });
    }

    function consultar(termino) {
      ultima = termino;
      if (cargando) { cargando.removeAttribute('hidden'); }
      if (cajaVacio) { cajaVacio.setAttribute('hidden', 'hidden'); }
      if (cajaVistos) { cajaVistos.setAttribute('hidden', 'hidden'); }
      if (cajaRecientes) { cajaRecientes.setAttribute('hidden', 'hidden'); }

      if (controlador) { controlador.abort(); }
      controlador = new AbortController();

      var url = urlPredictiva + '.json?q=' + encodeURIComponent(termino) +
        '&resources[type]=product,query&resources[limit]=' + limite +
        '&resources[options][unavailable_products]=last';

      fetch(url, { headers: { 'Accept': 'application/json' }, signal: controlador.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) { pintarResultados(d, termino); })
        .catch(function (err) {
          if (err && err.name === 'AbortError') { return; }
          if (cargando) { cargando.setAttribute('hidden', 'hidden'); }
        });
    }

    function pintarResultados(datos, termino) {
      if (cargando) { cargando.setAttribute('hidden', 'hidden'); }
      var res = (datos && datos.resources && datos.resources.results) || {};
      var productos = res.products || [];
      var consultas = res.queries || [];

      if (chipsSugerencias) {
        if (consultas.length) {
          chipsSugerencias.innerHTML = consultas.slice(0, 6).map(function (c) {
            var etiqueta = c.styled_text ? limpiarMarcas(c.styled_text) : escapar(c.text);
            return '<button type="button" class="busca-chip" data-consulta data-texto="' + escapar(c.text) + '">' + etiqueta + '</button>';
          }).join('');
          if (cajaSugerencias) { cajaSugerencias.removeAttribute('hidden'); }
        } else if (cajaSugerencias) {
          cajaSugerencias.setAttribute('hidden', 'hidden');
        }
      }

      if (!productos.length) {
        if (cajaResultados) { cajaResultados.setAttribute('hidden', 'hidden'); }
        if (cajaVacio) { cajaVacio.removeAttribute('hidden'); }
        return;
      }

      if (cajaVacio) { cajaVacio.setAttribute('hidden', 'hidden'); }
      if (tituloResultados) { tituloResultados.textContent = tituloBase + ' ' + termino; }
      if (verTodo) {
        verTodo.setAttribute('href', urlBusqueda + '?q=' + encodeURIComponent(termino));
        verTodo.textContent = verTodo.getAttribute('data-base') || verTodo.textContent;
      }

      gridResultados.innerHTML = productos.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        var marca = p.vendor ? '<span class="busca-res__marca">' + escapar(p.vendor) + '</span>' : '';
        var antes = '';
        if (p.compare_at_price_max && p.price_max && p.compare_at_price_max > p.price_max) {
          antes = '<span class="busca-res__antes">' + escapar(p.compare_at_price_max) + '</span>';
        }
        var precio = p.price ? '<span class="busca-res__p">' + escapar(p.price) + antes + '</span>' : '';
        return '<a class="busca-res" href="' + escapar(p.url) + '">' +
          '<span class="busca-res__media">' + (img ? '<img class="busca-res__img" src="' + escapar(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          marca +
          '<span class="busca-res__t">' + escapar(p.title) + '</span>' +
          precio +
          '</a>';
      }).join('');

      if (cajaResultados) { cajaResultados.removeAttribute('hidden'); }
    }

    if (verTodo) { verTodo.setAttribute('data-base', verTodo.textContent.trim()); }
    estadoInicial();
  }

  function todo() { document.querySelectorAll('[data-busca]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.busqNovaIniciado) { return; }
  window.busqNovaIniciado = true;

  function iniciar(seccion) {
    if (seccion.dataset.busqInit === 'true') { return; }
    seccion.dataset.busqInit = 'true';

    var panelFiltros = seccion.querySelector('[data-panel-filtros]');
    var veloFiltros = seccion.querySelector('[data-velo-filtros]');
    var formFiltros = seccion.querySelector('[data-form-filtros]');
    var ordenSelect = seccion.querySelector('[data-orden-select]');
    var toast = seccion.querySelector('[data-toast]');
    var temporizadorToast = null;

    function mostrarToast(texto) {
      if (!toast) { return; }
      toast.textContent = texto;
      toast.removeAttribute('hidden');
      if (temporizadorToast) { clearTimeout(temporizadorToast); }
      temporizadorToast = setTimeout(function () { toast.setAttribute('hidden', 'hidden'); }, 2200);
    }

    function abrirFiltros() {
      if (!panelFiltros) { return; }
      panelFiltros.classList.add('esta-abierto');
      if (veloFiltros) { veloFiltros.removeAttribute('hidden'); }
      document.body.classList.add('busq-sin-scroll');
    }

    function cerrarFiltros() {
      if (!panelFiltros) { return; }
      panelFiltros.classList.remove('esta-abierto');
      if (veloFiltros) { veloFiltros.setAttribute('hidden', 'hidden'); }
      document.body.classList.remove('busq-sin-scroll');
    }

    seccion.querySelectorAll('[data-abrir-filtros]').forEach(function (b) { b.addEventListener('click', abrirFiltros); });
    seccion.querySelectorAll('[data-cerrar-filtros]').forEach(function (b) { b.addEventListener('click', cerrarFiltros); });
    if (veloFiltros) { veloFiltros.addEventListener('click', cerrarFiltros); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cerrarFiltros(); } });

    function enviarFiltros() {
      if (!formFiltros) { return; }
      var datos = new FormData(formFiltros);
      var partes = [];
      datos.forEach(function (valor, clave) {
        if (valor === '' || valor === null) { return; }
        partes.push(encodeURIComponent(clave) + '=' + encodeURIComponent(valor));
      });
      window.location.href = window.location.pathname + '?' + partes.join('&');
    }

    if (formFiltros) {
      formFiltros.addEventListener('change', function (e) {
        if (e.target.matches('[data-filtro-input][type="checkbox"]')) { enviarFiltros(); }
      });
      formFiltros.querySelectorAll('[data-filtro-input][type="number"]').forEach(function (campo) {
        campo.addEventListener('change', enviarFiltros);
      });
      formFiltros.addEventListener('submit', function (e) { e.preventDefault(); enviarFiltros(); });
    }

    if (ordenSelect) {
      ordenSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', ordenSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    seccion.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (!add) { return; }
      e.preventDefault();
      var card = add.closest('[data-card]');
      if (!card) { return; }

      if (card.getAttribute('data-multi') === 'true') {
        window.location.href = card.getAttribute('data-url');
        return;
      }

      var id = card.getAttribute('data-variante');
      if (!id) { window.location.href = card.getAttribute('data-url'); return; }

      var txt = add.querySelector('.busq-add__txt');
      var original = txt ? txt.textContent : '';
      if (txt) { txt.textContent = 'Agregando'; }
      add.classList.add('esta-listo');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function () {
          if (txt) { txt.textContent = 'Agregado'; }
          mostrarToast('Agregado al carrito');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              document.querySelectorAll('.hn-carrito__num, .gyh-carrito .hn-carrito__num').forEach(function (n) {
                n.textContent = d.item_count;
                n.style.display = d.item_count > 0 ? 'flex' : 'none';
              });
            })
            .catch(function () {});
          setTimeout(function () {
            if (txt) { txt.textContent = original; }
            add.classList.remove('esta-listo');
          }, 1800);
        })
        .catch(function () {
          if (txt) { txt.textContent = original; }
          add.classList.remove('esta-listo');
          window.location.href = card.getAttribute('data-url');
        });
    });
  }

  function todo() { document.querySelectorAll('[data-busq]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider_street"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.ivIniciado === 'true') {
      return;
    }
    seccion.dataset.ivIniciado = 'true';

    var items = seccion.querySelectorAll('[data-iv-item]');

    function mostrar() {
      items.forEach(function (item, i) {
        setTimeout(function () {
          item.classList.add('iv-item--visible');
        }, i * 120);
      });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas, observador) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            mostrar();
            observador.disconnect();
          }
        });
      }, { threshold: 0.2 });
      obs.observe(seccion);
    } else {
      mostrar();
    }
  }

  function iniciarTodo() {
    document.querySelectorAll('.iv-seccion').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-los-mas-vendidos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.masVendidosIniciado) return;
    window.masVendidosIniciado = true;

    function actualizarContador() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          var contadores = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span[aria-hidden="true"]');
          contadores.forEach(function (el) {
            el.textContent = carrito.item_count;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('.mas-vendidos-agregar[data-variante]');
      if (!boton) return;

      evento.preventDefault();

      var seccion = boton.closest('.mas-vendidos-seccion');
      var accion = seccion ? seccion.getAttribute('data-accion-agregar') : 'confirmacion';
      var variante = boton.getAttribute('data-variante');
      var textoEl = boton.querySelector('.mas-vendidos-agregar-texto');
      var textoOriginal = textoEl ? textoEl.textContent : '';

      if (boton.dataset.cargando === 'true') return;
      boton.dataset.cargando = 'true';
      boton.classList.add('mas-vendidos-agregar--activo');
      if (textoEl) textoEl.textContent = 'A√±adiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variante, quantity: 1 })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('add-error');
          return respuesta.json();
        })
        .then(function () {
          if (accion === 'carrito') {
            window.location.href = '/cart';
            return;
          }
          boton.dataset.cargando = 'false';
          if (textoEl) textoEl.textContent = 'A√±adido ‚úì';
          actualizarContador();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            boton.classList.remove('mas-vendidos-agregar--activo');
            if (textoEl) textoEl.textContent = textoOriginal;
          }, 1700);
        })
        .catch(function () {
          boton.dataset.cargando = 'false';
          boton.classList.remove('mas-vendidos-agregar--activo');
          if (textoEl) textoEl.textContent = textoOriginal;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-nueva-cooleccion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.coleccionStreetIniciado) return;
    window.coleccionStreetIniciado = true;

    var seccion = document.querySelector('.coleccion-seccion');
    if (!seccion) return;

    var abrir = seccion.querySelector('[data-abrir-filtros]');
    var cerrar = seccion.querySelector('[data-cerrar-filtros]');
    var overlay = seccion.querySelector('[data-overlay]');

    function abrirFiltros() { seccion.classList.add('esta-abierto'); document.body.style.overflow = 'hidden'; }
    function cerrarFiltros() { seccion.classList.remove('esta-abierto'); document.body.style.overflow = ''; }

    if (abrir) abrir.addEventListener('click', abrirFiltros);
    if (cerrar) cerrar.addEventListener('click', cerrarFiltros);
    if (overlay) overlay.addEventListener('click', cerrarFiltros);

    var form = seccion.querySelector('[data-form-filtros]');
    var orden = seccion.querySelector('[data-orden]');
    var esEscritorio = function () { return window.matchMedia('(min-width: 990px)').matches; };

    function enviar() { if (form) form.submit(); }

    if (form) {
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (!t.hasAttribute('data-filtro-input')) return;
        if (t.type === 'number') return;
        enviar();
      });

      var temporizador;
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (!t.hasAttribute('data-filtro-input') || t.type !== 'number') return;
        clearTimeout(temporizador);
        temporizador = setTimeout(enviar, 700);
      });
    }

    if (orden) orden.addEventListener('change', function () { if (form) form.submit(); });

    function refrescarCarrito() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart.item_count;
          var selectores = '#cart-icon-bubble, .cart-count, .cart-count-bubble, [data-cart-count], .header__cart-count, .site-header__cart-count, .cart-link__bubble, .cart-item-count';
          document.querySelectorAll(selectores).forEach(function (el) { if (el) el.textContent = n; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function () {});
    }

    seccion.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (!add) return;
      e.preventDefault();
      var id = add.getAttribute('data-add');
      if (!id) return;
      var texto = add.querySelector('.coleccion-add-texto');
      var mas = add.querySelector('.coleccion-add-mas');
      var textoOriginal = texto ? texto.textContent : '';
      var masOriginal = mas ? mas.textContent : '+';
      if (mas) mas.textContent = '...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          add.classList.add('esta-agregado');
          if (mas) mas.textContent = '\u2713';
          if (texto) texto.textContent = 'Agregado';
          refrescarCarrito();
          setTimeout(function () { add.classList.remove('esta-agregado'); if (mas) mas.textContent = masOriginal; if (texto) texto.textContent = textoOriginal; }, 1800);
        })
        .catch(function () { if (mas) mas.textContent = masOriginal; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-nuevoheader-def"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.hnInit === 'true') { return; }
    raiz.dataset.hnInit = 'true';

    var cuerpo = document.body;
    var cabecera = raiz.querySelector('.hn-cab');
    var cajon = raiz.querySelector('.hn-cajon');
    var velo = raiz.querySelector('[data-hn-velo]');
    var buscador = raiz.querySelector('.hn-buscar');
    var escritorio = window.matchMedia('(min-width: 990px)');

    var hnAbrirTimer = null;
    var hnCerrarTimer = null;
    function cancelarTemporizadoresMega() {
      clearTimeout(hnAbrirTimer);
      clearTimeout(hnCerrarTimer);
    }
    function cerrarMegas() {
      cancelarTemporizadoresMega();
      raiz.querySelectorAll('.hn-mega').forEach(function (m) { m.classList.remove('hn-mega--abierto'); });
      raiz.querySelectorAll('.hn-menu__disparador').forEach(function (d) { d.classList.remove('hn-menu__disparador--activo'); d.setAttribute('aria-expanded', 'false'); });
    }
    function abrirMega(disp) {
      cancelarTemporizadoresMega();
      var id = disp.getAttribute('data-objetivo');
      var panel = raiz.querySelector('.hn-mega[data-panel="' + id + '"]');
      cerrarMegas();
      if (panel) { panel.classList.add('hn-mega--abierto'); disp.classList.add('hn-menu__disparador--activo'); disp.setAttribute('aria-expanded', 'true'); }
    }
    function programarCerrarMega() {
      clearTimeout(hnAbrirTimer);
      clearTimeout(hnCerrarTimer);
      hnCerrarTimer = setTimeout(cerrarMegas, 240);
    }
    raiz.querySelectorAll('.hn-menu__item').forEach(function (item) {
      var disp = item.querySelector('.hn-menu__disparador');
      item.addEventListener('mouseenter', function () {
        if (!escritorio.matches) { return; }
        cancelarTemporizadoresMega();
        if (disp) { hnAbrirTimer = setTimeout(function () { abrirMega(disp); }, 340); }
        else { programarCerrarMega(); }
      });
    });
    if (cabecera) {
      cabecera.addEventListener('mouseleave', programarCerrarMega);
      cabecera.addEventListener('mouseenter', function () { clearTimeout(hnCerrarTimer); });
    }
    raiz.querySelectorAll('.hn-mega').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(hnCerrarTimer); clearTimeout(hnAbrirTimer); });
      panel.addEventListener('mouseleave', programarCerrarMega);
    });
    raiz.querySelectorAll('.hn-menu__disparador').forEach(function (disp) {
      disp.addEventListener('focus', function () { if (escritorio.matches) { abrirMega(disp); } });
      disp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          abrirMega(disp);
          var panel = raiz.querySelector('.hn-mega[data-panel="' + disp.getAttribute('data-objetivo') + '"]');
          if (panel) { var primer = panel.querySelector('a'); if (primer) { primer.focus(); } }
        }
      });
    });
    if (cabecera) {
      cabecera.addEventListener('focusout', function () {
        setTimeout(function () { if (!cabecera.contains(document.activeElement)) { cerrarMegas(); } }, 0);
      });
    }

    function cerrarCajon() {
      if (cajon) {
        cajon.classList.remove('hn-cajon--abierto');
        cajon.setAttribute('aria-hidden', 'true');
        cajon.inert = true;
      }
      if (hamburguesa) { hamburguesa.setAttribute('aria-expanded', 'false'); }
      if (velo && (!buscador || !buscador.classList.contains('hn-buscar--abierta'))) { velo.classList.remove('hn-velo--visible'); }
      cuerpo.classList.remove('gyh-sin-scroll');
    }
    function abrirCajon() {
      cerrarBuscador();
      cerrarMegas();
      if (cajon) {
        cajon.classList.add('hn-cajon--abierto');
        cajon.setAttribute('aria-hidden', 'false');
        cajon.inert = false;
      }
      if (hamburguesa) { hamburguesa.setAttribute('aria-expanded', 'true'); }
      if (velo) { velo.classList.add('hn-velo--visible'); }
      cuerpo.classList.add('gyh-sin-scroll');
      var cierre = cajon && cajon.querySelector('.hn-cajon__cerrar');
      if (cierre) { cierre.focus(); }
    }
    escritorio.addEventListener('change', function () { cerrarCajon(); cerrarMegas(); });
    var hamburguesa = raiz.querySelector('.hn-hamburguesa');
    if (hamburguesa) { hamburguesa.addEventListener('click', abrirCajon); }
    var cerrarC = raiz.querySelector('.hn-cajon__cerrar');
    if (cerrarC) { cerrarC.addEventListener('click', cerrarCajon); }

    raiz.querySelectorAll('[data-hn-acordeon]').forEach(function (b) {
      b.addEventListener('click', function () {
        var grupo = b.closest('.hn-cajon__grupo');
        if (!grupo) { return; }
        var abierto = grupo.classList.contains('hn-cajon__grupo--abierto');
        raiz.querySelectorAll('.hn-cajon__grupo').forEach(function (g) {
          g.classList.remove('hn-cajon__grupo--abierto');
          var btn = g.querySelector('[data-hn-acordeon]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); }
        });
        if (!abierto) { grupo.classList.add('hn-cajon__grupo--abierto'); b.setAttribute('aria-expanded', 'true'); }
      });
    });

    function cerrarBuscador() {
      if (buscador) { buscador.classList.remove('hn-buscar--abierta'); }
      if (velo && (!cajon || !cajon.classList.contains('hn-cajon--abierto'))) { velo.classList.remove('hn-velo--visible'); }
    }
    function abrirBuscador() {
      if (!buscador) { return; }
      cerrarCajon();
      cerrarMegas();
      buscador.classList.add('hn-buscar--abierta');
      if (velo) { velo.classList.add('hn-velo--visible'); }
      var campo = buscador.querySelector('[data-hn-campo]');
      if (campo) { setTimeout(function () { campo.focus(); }, 120); }
    }
    var abrirBus = raiz.querySelector('.hn-abrir-busqueda');
    if (abrirBus) { abrirBus.addEventListener('click', abrirBuscador); }
    var cerrarBus = raiz.querySelector('.hn-buscar__cerrar');
    if (cerrarBus) { cerrarBus.addEventListener('click', cerrarBuscador); }
    if (velo) { velo.addEventListener('click', function () { cerrarCajon(); cerrarBuscador(); }); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cerrarMegas(); cerrarCajon(); cerrarBuscador(); } });

    raiz.querySelectorAll('[data-hn-buscar]').forEach(function (caja) {
      var campo = caja.querySelector('[data-hn-campo]');
      var panel = caja.querySelector('[data-hn-resultados]');
      var base = caja.getAttribute('data-predictivo-url') || '/search/suggest';
      var buscar = caja.getAttribute('data-buscar-url') || '/search';
      if (!campo || !panel) { return; }
      var timer = null, ultima = '';

      function pintar(datos, term) {
        var r = (datos && datos.resources && datos.resources.results) || {};
        var prods = r.products || [], cols = r.collections || [];
        var html = '';
        if (cols.length) {
          html += '<p class="hn-buscar__grupo">Colecciones</p><div class="hn-res-chips">';
          cols.slice(0, 6).forEach(function (c) { html += '<a class="hn-res-chip" href="' + c.url + '">' + c.title + '</a>'; });
          html += '</div>';
        }
        if (prods.length) {
          html += '<p class="hn-buscar__grupo">Productos</p>';
          prods.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
            var precio = p.price ? ('<span class="hn-res__p">' + p.price + '</span>') : '';
            html += '<a class="hn-res" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="hn-res__ph"></span>') + '<span class="hn-res__d"><span class="hn-res__n">' + p.title + '</span>' + precio + '</span></a>';
          });
          html += '<a class="hn-res-ver" href="' + buscar + '?q=' + encodeURIComponent(term) + '">Ver todos los resultados</a>';
        } else if (!cols.length) {
          html += '<p class="hn-res-vacio">Sin resultados para &ldquo;' + term + '&rdquo;.</p>';
        }
        panel.innerHTML = html;
        panel.classList.add('hn-buscar__panel--abierto');
      }

      function pedir(term) {
        fetch(base + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (d) { pintar(d, term); }).catch(function () {});
      }

      campo.addEventListener('input', function () {
        var t = campo.value.trim();
        if (timer) { clearTimeout(timer); }
        if (t.length < 2) { panel.classList.remove('hn-buscar__panel--abierto'); panel.innerHTML = ''; ultima = ''; return; }
        if (t === ultima) { return; }
        ultima = t;
        timer = setTimeout(function () { pedir(t); }, 220);
      });
    });

    var anuncios = raiz.querySelectorAll('[data-hn-anuncio]');
    if (anuncios.length > 1) {
      var idx = 0;
      setInterval(function () {
        anuncios[idx].classList.remove('hn-anuncio--activo');
        idx = (idx + 1) % anuncios.length;
        anuncios[idx].classList.add('hn-anuncio--activo');
      }, 4200);
    }

    if (cabecera && cabecera.classList.contains('gyh-cabecera--fija')) {
      var esp = raiz.parentNode ? raiz.parentNode.querySelector('.gyh-espaciador') : null;
      if (!esp) { esp = document.createElement('div'); esp.className = 'gyh-espaciador'; raiz.parentNode.insertBefore(esp, raiz.nextSibling); }
      function fijarAlto(a) { esp.style.setProperty('height', a + 'px', 'important'); document.documentElement.style.setProperty('--gyh-altura-cabecera', a + 'px'); }
      function ajustar() {
        var estaba = cabecera.classList.contains('hn-cab--desplazada');
        if (estaba) { cabecera.classList.remove('hn-cab--desplazada'); }
        fijarAlto(cabecera.offsetHeight);
        if (estaba) { cabecera.classList.add('hn-cab--desplazada'); }
      }
      ajustar();
      window.addEventListener('resize', ajustar);
      window.addEventListener('load', ajustar);
      window.addEventListener('orientationchange', ajustar);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(ajustar); }
    }

    var ticking = false;
    function estado() {
      if (window.pageYOffset > 12) { cabecera.classList.add('hn-cab--desplazada'); }
      else { cabecera.classList.remove('hn-cab--desplazada'); }
      ticking = false;
    }
    if (cabecera) {
      estado();
      window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(estado); ticking = true; } }, { passive: true });
    }

    var nums = raiz.querySelectorAll('.hn-carrito__num');
    if (nums.length) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        nums.forEach(function (n) { n.textContent = d.item_count; n.style.display = d.item_count > 0 ? 'flex' : 'none'; });
      }).catch(function () {});
    }
  }

  function todo() { document.querySelectorAll('.hn-raiz').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-nuevos-ingresos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.nuevosIngresosIniciado) return;
    window.nuevosIngresosIniciado = true;

    function actualizarContador() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          var contadores = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span[aria-hidden="true"]');
          contadores.forEach(function (el) {
            el.textContent = carrito.item_count;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('.nuevos-ingresos-agregar[data-variante]');
      if (!boton) return;

      evento.preventDefault();

      var seccion = boton.closest('.nuevos-ingresos-seccion');
      var accion = seccion ? seccion.getAttribute('data-accion-agregar') : 'confirmacion';
      var variante = boton.getAttribute('data-variante');
      var textoEl = boton.querySelector('.nuevos-ingresos-agregar-texto');
      var textoOriginal = textoEl ? textoEl.textContent : '';

      if (boton.dataset.cargando === 'true') return;
      boton.dataset.cargando = 'true';
      boton.classList.add('nuevos-ingresos-agregar--activo');
      if (textoEl) textoEl.textContent = 'A√±adiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variante, quantity: 1 })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('add-error');
          return respuesta.json();
        })
        .then(function () {
          if (accion === 'carrito') {
            window.location.href = '/cart';
            return;
          }
          boton.dataset.cargando = 'false';
          if (textoEl) textoEl.textContent = 'A√±adido ‚úì';
          actualizarContador();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            boton.classList.remove('nuevos-ingresos-agregar--activo');
            if (textoEl) textoEl.textContent = textoOriginal;
          }, 1700);
        })
        .catch(function () {
          boton.dataset.cargando = 'false';
          boton.classList.remove('nuevos-ingresos-agregar--activo');
          if (textoEl) textoEl.textContent = textoOriginal;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-pag-prod-nuevo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.productoNovaIniciado) { return; }
  window.productoNovaIniciado = true;

  var CLAVE_VISTOS = 'pro_vistos';

  function formatoCOP(cents) {
    var n = Math.round((cents || 0) / 100);
    return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function miniatura(fuente, ancho) {
    if (fuente && typeof fuente === 'object') { fuente = fuente.src || fuente.url || ''; }
    if (!fuente) { return ''; }
    var u = String(fuente);
    if (u.indexOf('//') === 0) { u = 'https:' + u; }
    if (u.indexOf('width=') !== -1) { return u; }
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + ancho;
  }

  function raizTienda() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function leerVistos() {
    try {
      var lista = JSON.parse(localStorage.getItem(CLAVE_VISTOS));
      return Array.isArray(lista) ? lista : [];
    } catch (e) { return []; }
  }

  function guardarVisto(handle) {
    if (!handle) { return; }
    var lista = leerVistos().filter(function (h) { return h !== handle; });
    lista.unshift(handle);
    try { localStorage.setItem(CLAVE_VISTOS, JSON.stringify(lista.slice(0, 20))); } catch (e) {}
  }

  function esEscritorio() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function normalizar(s) { return (s || '').toLowerCase().trim(); }

  function crearCard(p) {
    var a = document.createElement('a');
    a.className = 'producto-card';
    a.href = p.url;
    var cont = document.createElement('div');
    cont.className = 'producto-card-img';
    var src = miniatura(p.featured_image || p.image, 600);
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = p.title || '';
      img.loading = 'lazy';
      cont.appendChild(img);
    }
    a.appendChild(cont);
    var nom = document.createElement('span');
    nom.className = 'producto-card-nombre';
    nom.textContent = p.title || '';
    a.appendChild(nom);
    var pre = document.createElement('span');
    pre.className = 'producto-card-precio';
    pre.textContent = formatoCOP(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      var antes = document.createElement('s');
      antes.textContent = formatoCOP(p.compare_at_price);
      pre.appendChild(antes);
    }
    a.appendChild(pre);
    return a;
  }

  function iniciar(seccion) {
    if (seccion.dataset.proInit === 'true') { return; }
    seccion.dataset.proInit = 'true';

    var inputId = seccion.querySelector('[data-input-id]');
    var inputQty = seccion.querySelector('[data-input-qty]');
    var precioEl = seccion.querySelector('[data-precio]');
    var antesEl = seccion.querySelector('[data-antes]');
    var descEl = seccion.querySelector('[data-descuento]');
    var galeria = seccion.querySelector('[data-galeria]');
    var barra = seccion.querySelector('[data-barra]');
    var barraPrecio = seccion.querySelector('[data-barra-precio]');
    var qtyInput = seccion.querySelector('[data-cantidad-input]');
    var info = seccion.querySelector('.producto-info');

    var envioEl = seccion.querySelector('[data-envio]');
    var envioTexto = seccion.querySelector('[data-envio-texto]');
    var envioRelleno = seccion.querySelector('[data-envio-relleno]');
    var envioCamion = seccion.querySelector('[data-envio-camion]');
    var tplFalta = seccion.querySelector('[data-txt-falta]');
    var tplOk = seccion.querySelector('[data-txt-ok]');
    var txtFalta = tplFalta ? tplFalta.textContent.trim() : '';
    var txtOk = tplOk ? tplOk.textContent.trim() : '';

    var colorIndex = parseInt(seccion.getAttribute('data-color-index'), 10);
    var galeriaPorColor = seccion.getAttribute('data-galeria-por-color') === 'true';
    var umbral = parseInt(seccion.getAttribute('data-umbral'), 10) || 0;
    var carritoCents = parseInt(seccion.getAttribute('data-carrito'), 10) || 0;
    var stickyTop = parseInt(seccion.getAttribute('data-sticky-top'), 10);
    if (isNaN(stickyTop)) { stickyTop = 100; }
    var incluirActual = true;

    var variantes = [];
    try {
      var crudo = seccion.querySelector('[data-variantes]');
      if (crudo) { variantes = JSON.parse(crudo.textContent); }
    } catch (e) { variantes = []; }

    var seleccion = [];
    var actual = variantes.filter(function (v) { return String(v.id) === String(inputId && inputId.value); })[0];
    if (actual) { seleccion = actual.opciones.slice(); }
    var varActual = actual || variantes[0] || null;

    function cantidadActual() {
      return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    }

    function pintarEnvio() {
      if (!envioEl || umbral <= 0) { return; }
      var precio = varActual ? varActual.precio : 0;
      var total = carritoCents + (incluirActual ? precio * cantidadActual() : 0);
      var pct = Math.max(0, Math.min(100, Math.round(total * 100 / umbral)));
      if (envioRelleno) { envioRelleno.style.width = pct + '%'; }
      if (envioCamion) { envioCamion.style.left = pct + '%'; }
      if (total >= umbral) {
        envioEl.classList.add('producto-envio--ok');
        if (envioTexto) { envioTexto.textContent = txtOk; }
      } else {
        envioEl.classList.remove('producto-envio--ok');
        if (envioTexto) { envioTexto.innerHTML = escapar(txtFalta).replace('[monto]', '<b>' + formatoCOP(umbral - total) + '</b>'); }
      }
    }

    function slidesVisibles() {
      return Array.prototype.slice.call(seccion.querySelectorAll('[data-slide]')).filter(function (s) { return !s.hasAttribute('hidden'); });
    }

    function marcarActivo(indice) {
      seccion.querySelectorAll('[data-punto]').forEach(function (p) { p.classList.toggle('esta-activo', p.getAttribute('data-indice') === String(indice)); });
    }

    function irASlide(el) {
      if (!galeria || !el) { return; }
      marcarActivo(el.getAttribute('data-indice'));
      if (esEscritorio()) { return; }
      galeria.scrollTo({ left: el.offsetLeft - galeria.offsetLeft, behavior: 'smooth' });
    }

    function ordenarGrid() {
      var lista = slidesVisibles();
      seccion.querySelectorAll('[data-slide]').forEach(function (s) { s.classList.remove('es-ancha'); });
      if (!lista.length) { return; }
      lista[0].classList.add('es-ancha');
      if (lista.length > 1 && (lista.length - 1) % 2 === 1) { lista[lista.length - 1].classList.add('es-ancha'); }
    }

    function filtrarGaleria(color) {
      if (!galeria || !galeriaPorColor) { return; }
      color = normalizar(color);
      if (!color) { return; }
      var slides = seccion.querySelectorAll('[data-slide]');
      var puntos = seccion.querySelectorAll('[data-punto]');
      var coincidencias = 0;
      slides.forEach(function (s) { if (normalizar(s.getAttribute('data-media-color')).indexOf(color) !== -1) { coincidencias++; } });
      slides.forEach(function (s, i) {
        var visible = coincidencias === 0 || normalizar(s.getAttribute('data-media-color')).indexOf(color) !== -1;
        if (visible) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', 'hidden'); }
        if (puntos[i]) { if (visible) { puntos[i].removeAttribute('hidden'); } else { puntos[i].setAttribute('hidden', 'hidden'); } }
      });
      galeria.scrollLeft = 0;
      var primeros = slidesVisibles();
      if (primeros.length) { marcarActivo(primeros[0].getAttribute('data-indice')); }
      ordenarGrid();
    }

    function slidePorVariante(v) {
      if (!v) { return null; }
      var lista = slidesVisibles();
      var i;
      if (v.media) {
        for (i = 0; i < lista.length; i++) {
          if (lista[i].getAttribute('data-media-id') === String(v.media)) { return lista[i]; }
        }
      }
      if (v.imagen) {
        var objetivo = v.imagen.split('?')[0];
        for (i = 0; i < lista.length; i++) {
          var img = lista[i].querySelector('img');
          if (img && img.src.split('?')[0] === objetivo) { return lista[i]; }
        }
      }
      return null;
    }

    function marcarDisponibilidad() {
      seccion.querySelectorAll('[data-opt]').forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-opt'), 10);
        var val = btn.getAttribute('data-val');
        var prueba = seleccion.slice();
        prueba[idx] = val;
        var existe = variantes.filter(function (v) {
          return v.opciones.every(function (op, i) { return i === idx ? op === val : (prueba[i] === undefined || op === prueba[i]); });
        });
        var hayStock = existe.some(function (v) { return v.disponible; });
        btn.classList.toggle('esta-agotado', !hayStock);
      });
    }

    function buscarVariante() {
      return variantes.filter(function (v) { return v.opciones.every(function (op, i) { return op === seleccion[i]; }); })[0];
    }

    function ajustarSticky() {
      if (!info) { return; }
      if (!esEscritorio()) { info.style.top = ''; return; }
      var alto = info.offsetHeight;
      var disponible = window.innerHeight - stickyTop - 20;
      info.style.top = (alto <= disponible ? stickyTop : (window.innerHeight - alto - 20)) + 'px';
    }

    function aplicarVariante(v) {
      if (!v) { return; }
      varActual = v;
      incluirActual = true;
      if (inputId) { inputId.value = v.id; }
      if (precioEl) { precioEl.textContent = formatoCOP(v.precio); }
      if (barraPrecio) { barraPrecio.textContent = formatoCOP(v.precio); }
      if (antesEl) {
        if (v.antes && v.antes > v.precio) {
          antesEl.textContent = formatoCOP(v.antes);
          antesEl.style.display = '';
          if (descEl) { descEl.textContent = '-' + Math.round((v.antes - v.precio) * 100 / v.antes) + '%'; descEl.style.display = ''; }
        } else {
          antesEl.style.display = 'none';
          if (descEl) { descEl.style.display = 'none'; }
        }
      }
      pintarEnvio();
      if (!isNaN(colorIndex) && colorIndex >= 0 && v.opciones) { filtrarGaleria(v.opciones[colorIndex]); }
      var destino = slidePorVariante(v);
      if (destino) { irASlide(destino); }
      seccion.querySelectorAll('[data-agregar]').forEach(function (b) {
        if (v.disponible) { b.removeAttribute('disabled'); } else { b.setAttribute('disabled', 'disabled'); }
      });
      marcarDisponibilidad();
      ajustarSticky();
    }

    if (actual && !isNaN(colorIndex) && colorIndex >= 0 && actual.opciones) { filtrarGaleria(actual.opciones[colorIndex]); }
    ordenarGrid();
    marcarDisponibilidad();
    pintarEnvio();

    function ajustarCantidad(delta) {
      if (!qtyInput) { return; }
      var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      qtyInput.value = n;
      if (inputQty) { inputQty.value = n; }
      incluirActual = true;
      pintarEnvio();
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var n = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = n;
        if (inputQty) { inputQty.value = n; }
        incluirActual = true;
        pintarEnvio();
      });
    }

    if (galeria) {
      galeria.addEventListener('scroll', function () {
        if (esEscritorio()) { return; }
        var lista = slidesVisibles();
        if (!lista.length) { return; }
        var idx = Math.round(galeria.scrollLeft / galeria.clientWidth);
        var el = lista[Math.min(idx, lista.length - 1)];
        if (el) { marcarActivo(el.getAttribute('data-indice')); }
      }, { passive: true });
    }

    seccion.querySelectorAll('[data-flecha]').forEach(function (fl) {
      fl.addEventListener('click', function () {
        var lista = slidesVisibles();
        if (!lista.length || !galeria) { return; }
        var dir = parseInt(fl.getAttribute('data-flecha'), 10) || 1;
        var actualIdx = Math.round(galeria.scrollLeft / galeria.clientWidth);
        var nuevo = Math.max(0, Math.min(lista.length - 1, actualIdx + dir));
        irASlide(lista[nuevo]);
      });
    });

    var lightbox = seccion.querySelector('[data-lightbox]');
    var lbImg = seccion.querySelector('[data-lightbox-img]');
    var lbContador = seccion.querySelector('[data-lightbox-contador]');
    var lbLista = [];
    var lbIdx = 0;

    function pintarLightbox() {
      var el = lbLista[lbIdx];
      if (!el || !lbImg) { return; }
      lbImg.src = el.getAttribute('data-grande') || '';
      if (lbContador) { lbContador.textContent = (lbIdx + 1) + ' / ' + lbLista.length; }
    }
    function abrirLightbox(el) {
      if (!lightbox) { return; }
      lbLista = slidesVisibles();
      if (!lbLista.length) { return; }
      lbIdx = Math.max(0, lbLista.indexOf(el));
      lightbox.classList.toggle('producto-lightbox--unica', lbLista.length < 2);
      pintarLightbox();
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function moverLightbox(dir) {
      if (lbLista.length < 2) { return; }
      lbIdx = (lbIdx + dir + lbLista.length) % lbLista.length;
      pintarLightbox();
    }
    function cerrarLightbox() {
      if (!lightbox || lightbox.hasAttribute('hidden')) { return; }
      lightbox.setAttribute('hidden', 'hidden');
      document.body.style.overflow = '';
    }

    var btnZoom = seccion.querySelector('[data-zoom]');
    if (btnZoom) {
      btnZoom.addEventListener('click', function () {
        var lista = slidesVisibles();
        if (!lista.length || !galeria) { return; }
        var idx = Math.round(galeria.scrollLeft / galeria.clientWidth);
        abrirLightbox(lista[Math.min(idx, lista.length - 1)]);
      });
    }
    var btnCerrarLb = seccion.querySelector('[data-lightbox-cerrar]');
    if (btnCerrarLb) { btnCerrarLb.addEventListener('click', cerrarLightbox); }
    seccion.querySelectorAll('[data-lightbox-nav]').forEach(function (b) {
      b.addEventListener('click', function () { moverLightbox(parseInt(b.getAttribute('data-lightbox-nav'), 10) || 1); });
    });
    if (lightbox) {
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) { cerrarLightbox(); } });
      var toqueX = null;
      lightbox.addEventListener('touchstart', function (e) { toqueX = e.touches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        if (toqueX === null) { return; }
        var dx = e.changedTouches[0].clientX - toqueX;
        if (Math.abs(dx) > 45) { moverLightbox(dx < 0 ? 1 : -1); }
        toqueX = null;
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hasAttribute('hidden')) { return; }
      if (e.key === 'Escape') { cerrarLightbox(); }
      if (e.key === 'ArrowLeft') { moverLightbox(-1); }
      if (e.key === 'ArrowRight') { moverLightbox(1); }
    });

    seccion.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var destino = tab.getAttribute('data-tab');
        seccion.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.remove('esta-activa'); });
        tab.classList.add('esta-activa');
        seccion.querySelectorAll('[data-panel]').forEach(function (p) {
          p.classList.toggle('esta-activo', p.getAttribute('data-panel') === destino);
        });
      });
    });

    var verMas = seccion.querySelector('[data-vermas]');
    var recorte = seccion.querySelector('[data-recorte]');
    if (verMas && recorte) {
      var textoCerrado = verMas.querySelector('span').textContent;
      verMas.addEventListener('click', function () {
        var abierto = recorte.classList.toggle('esta-abierto');
        verMas.classList.toggle('esta-abierto', abierto);
        verMas.querySelector('span').textContent = abierto ? 'Ver menos' : textoCerrado;
      });
      if (recorte.scrollHeight <= 212) { verMas.setAttribute('hidden', 'hidden'); recorte.classList.add('esta-abierto'); }
    }

    var nombreHermano = seccion.querySelector('[data-hermano-nombre]');
    if (nombreHermano) {
      var nombreBase = nombreHermano.textContent;
      seccion.querySelectorAll('.producto-hermano').forEach(function (h) {
        h.addEventListener('mouseenter', function () { nombreHermano.textContent = h.getAttribute('data-nombre-color') || nombreBase; });
        h.addEventListener('mouseleave', function () { nombreHermano.textContent = nombreBase; });
      });
    }

    seccion.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-opt]');
      if (opt) {
        var idx = parseInt(opt.getAttribute('data-opt'), 10);
        var val = opt.getAttribute('data-val');
        seleccion[idx] = val;
        var grupo = opt.parentElement;
        grupo.querySelectorAll('[data-opt]').forEach(function (b) { b.classList.remove('esta-activo'); });
        opt.classList.add('esta-activo');
        var etiqueta = seccion.querySelector('.producto-opcion[data-opcion-index="' + idx + '"] [data-opcion-valor]');
        if (etiqueta) { etiqueta.textContent = val; }
        aplicarVariante(buscarVariante());
        return;
      }

      var punto = e.target.closest('[data-punto]');
      if (punto) {
        var destinoPunto = seccion.querySelector('[data-slide][data-indice="' + punto.getAttribute('data-indice') + '"]');
        if (destinoPunto) { irASlide(destinoPunto); }
        return;
      }

      var slide = e.target.closest('[data-slide]');
      if (slide && slide.hasAttribute('data-grande')) { abrirLightbox(slide); return; }

      if (e.target.closest('[data-menos]')) { ajustarCantidad(-1); return; }
      if (e.target.closest('[data-mas]')) { ajustarCantidad(1); return; }

      var agregar = e.target.closest('[data-agregar]');
      if (agregar && !agregar.hasAttribute('disabled')) { e.preventDefault(); enviarCarrito(agregar); return; }
    });

    function enviarCarrito(boton) {
      if (!inputId || !inputId.value) { return; }
      var cantidad = cantidadActual();
      var textoEl = boton.querySelector('[data-agregar-texto]') || boton;
      var original = textoEl.textContent;
      textoEl.textContent = 'Procesando';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: inputId.value, quantity: cantidad }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
        .then(function () {
          var accion = seccion.getAttribute('data-accion-comprar');
          if (accion === 'checkout') { window.location.href = '/checkout'; return; }
          if (accion === 'carrito') { window.location.href = '/cart'; return; }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              carritoCents = d.total_price || 0;
              incluirActual = false;
              pintarEnvio();
              document.querySelectorAll('.hn-carrito__num').forEach(function (n) {
                n.textContent = d.item_count;
                n.style.display = d.item_count > 0 ? 'flex' : 'none';
              });
            })
            .catch(function () {});
          textoEl.textContent = 'Agregado';
          setTimeout(function () { textoEl.textContent = original; }, 1800);
        })
        .catch(function () { textoEl.textContent = original; });
    }

    function fmtFecha(d) {
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      return d.getDate() + ' ' + meses[d.getMonth()];
    }
    function sumarHabiles(dias) {
      var d = new Date();
      var s = 0;
      while (s < dias) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) { s++; } }
      return d;
    }
    var dMin = parseInt(seccion.getAttribute('data-dias-min'), 10) || 2;
    var dMax = parseInt(seccion.getAttribute('data-dias-max'), 10) || 5;
    var fMin = sumarHabiles(dMin);
    var fMax = sumarHabiles(dMax);
    var eMin = seccion.querySelector('[data-fecha-min]'); if (eMin) { eMin.textContent = fmtFecha(fMin); }
    var eMax = seccion.querySelector('[data-fecha-max]'); if (eMax) { eMax.textContent = fmtFecha(fMax); }
    var pa1 = seccion.querySelector('[data-fecha-paso1]'); if (pa1) { pa1.textContent = 'Hoy'; }
    var pa2 = seccion.querySelector('[data-fecha-paso2]'); if (pa2) { pa2.textContent = fmtFecha(sumarHabiles(1)); }
    var pa3 = seccion.querySelector('[data-fecha-paso3]'); if (pa3) { pa3.textContent = fmtFecha(fMin) + ' - ' + fmtFecha(fMax); }

    function moverCarrusel(grid, dir) {
      if (!grid) { return; }
      grid.scrollBy({ left: dir * Math.round(grid.clientWidth * 0.8), behavior: 'smooth' });
    }
    var gridRel = seccion.querySelector('[data-relacionados]');
    seccion.querySelectorAll('[data-rel-flecha]').forEach(function (b) {
      b.addEventListener('click', function () { moverCarrusel(gridRel, parseInt(b.getAttribute('data-rel-flecha'), 10) || 1); });
    });

    var bloqueRecos = seccion.querySelector('[data-recos-bloque]');
    var recos = seccion.querySelector('[data-recos]');
    seccion.querySelectorAll('[data-reco-flecha]').forEach(function (b) {
      b.addEventListener('click', function () { moverCarrusel(recos, parseInt(b.getAttribute('data-reco-flecha'), 10) || 1); });
    });

    var handleActual = seccion.getAttribute('data-handle') || '';
    var productoId = seccion.getAttribute('data-producto-id') || '';
    var usarRespaldo = seccion.getAttribute('data-respaldo') === 'true';
    var previos = leerVistos().filter(function (h) { return h && h !== handleActual; }).slice(0, 12);
    guardarVisto(handleActual);

    function pintarRecos(lista) {
      if (!bloqueRecos || !recos || !lista.length) { return; }
      recos.innerHTML = '';
      lista.forEach(function (p) { recos.appendChild(crearCard(p)); });
      bloqueRecos.removeAttribute('hidden');
    }

    function cargarRespaldo() {
      if (!usarRespaldo || !productoId) { return; }
      fetch(raizTienda() + 'recommendations/products.json?product_id=' + productoId + '&intent=related&limit=10', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var lista = ((d && d.products) || []).filter(function (p) { return p && p.handle !== handleActual && p.available !== false; });
          pintarRecos(lista.slice(0, 10));
        })
        .catch(function () {});
    }

    if (bloqueRecos && recos) {
      if (previos.length) {
        Promise.all(previos.map(function (h) {
          return fetch(raizTienda() + 'products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (lista) {
          var validos = lista.filter(function (p) { return p && p.available; }).slice(0, 10);
          if (validos.length) { pintarRecos(validos); } else { cargarRespaldo(); }
        });
      } else {
        cargarRespaldo();
      }
    }

    var formPrincipal = seccion.querySelector('.producto-form');
    if (barra && formPrincipal && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting) { barra.setAttribute('hidden', 'hidden'); }
          else if (en.boundingClientRect.top < 0) { barra.removeAttribute('hidden'); }
          else { barra.setAttribute('hidden', 'hidden'); }
        });
      }, { threshold: 0 }).observe(formPrincipal);
    }

    ajustarSticky();
    window.addEventListener('resize', ajustarSticky);
    window.addEventListener('load', ajustarSticky);
    if (info && 'ResizeObserver' in window) { new ResizeObserver(ajustarSticky).observe(info); }
  }

  function todo() { document.querySelectorAll('.producto-seccion').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-tarjeteros-cuero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.tarjeteroIniciado) return;
    window.tarjeteroIniciado = true;

    var seccion = document.querySelector('.tarjetero-seccion');
    if (!seccion) return;

    var inputId = seccion.querySelector('[data-input-id]');
    var imagenPrincipal = seccion.querySelector('[data-imagen-principal]');
    var precioEl = seccion.querySelector('[data-precio]');
    var antesEl = seccion.querySelector('[data-precio-antes]');
    var nombreColor = seccion.querySelector('[data-color-nombre]');
    var stockTexto = seccion.querySelector('[data-stock-texto]');
    var urgencia = seccion.querySelector('[data-urgencia]');
    var umbral = 15;
    var textoGenerico = stockTexto ? stockTexto.textContent : '';

    function seleccionarColor(swatch) {
      var swatches = seccion.querySelectorAll('.tarjetero-swatch');
      swatches.forEach(function (s) { s.classList.remove('esta-activo'); });
      swatch.classList.add('esta-activo');

      if (inputId) inputId.value = swatch.getAttribute('data-id');
      if (nombreColor) nombreColor.textContent = swatch.getAttribute('data-nombre');
      if (precioEl && swatch.getAttribute('data-precio')) precioEl.textContent = swatch.getAttribute('data-precio');
      if (antesEl) {
        var antes = swatch.getAttribute('data-antes');
        if (antes) { antesEl.textContent = antes; antesEl.style.display = ''; }
        else { antesEl.style.display = 'none'; }
      }
      var img = swatch.getAttribute('data-imagen');
      if (img && imagenPrincipal) {
        imagenPrincipal.src = img;
        var minis = seccion.querySelectorAll('.tarjetero-miniatura');
        minis.forEach(function (m) { m.classList.remove('esta-activa'); });
      }

      var disponible = swatch.getAttribute('data-disponible') === 'true';
      var botones = seccion.querySelectorAll('[data-comprar]');
      botones.forEach(function (b) {
        if (disponible) { b.removeAttribute('disabled'); }
        else { b.setAttribute('disabled', 'disabled'); }
      });

      if (stockTexto) {
        var stock = parseInt(swatch.getAttribute('data-stock'), 10);
        if (!disponible) {
          stockTexto.textContent = 'Agotado en este color';
          if (urgencia) urgencia.style.display = '';
        } else if (!isNaN(stock) && stock > 0 && stock <= umbral) {
          stockTexto.textContent = 'Solo quedan ' + stock + ' unidades!';
          if (urgencia) urgencia.style.display = '';
        } else {
          stockTexto.textContent = textoGenerico;
          if (urgencia) urgencia.style.display = '';
        }
      }
    }

    seccion.addEventListener('click', function (e) {
      var swatch = e.target.closest('.tarjetero-swatch');
      if (swatch) { seleccionarColor(swatch); return; }

      var mini = e.target.closest('.tarjetero-miniatura');
      if (mini && imagenPrincipal) {
        imagenPrincipal.src = mini.getAttribute('data-mini');
        seccion.querySelectorAll('.tarjetero-miniatura').forEach(function (m) { m.classList.remove('esta-activa'); });
        mini.classList.add('esta-activa');
        return;
      }

      var comprar = e.target.closest('[data-comprar]');
      if (comprar && !comprar.hasAttribute('disabled')) {
        e.preventDefault();
        comprarAhora(comprar);
      }
    });

    function comprarAhora(boton) {
      if (!inputId || !inputId.value) return;
      var accion = seccion.getAttribute('data-accion-comprar');
      var textoEl = boton.querySelector('[data-comprar-texto]');
      var textoOriginal = textoEl ? textoEl.textContent : boton.textContent;
      if (textoEl) textoEl.textContent = 'Procesando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: inputId.value, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function () {
          if (accion === 'carrito') { window.location.href = '/cart'; }
          else { window.location.href = '/checkout'; }
        })
        .catch(function () {
          if (textoEl) textoEl.textContent = textoOriginal;
        });
    }

    function fmtFecha(d) {
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      return d.getDate() + ' ' + meses[d.getMonth()];
    }

    function sumarHabiles(dias) {
      var d = new Date();
      var sumados = 0;
      while (sumados < dias) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) sumados++;
      }
      return d;
    }

    var diasMin = parseInt(seccion.getAttribute('data-dias-min'), 10) || 2;
    var diasMax = parseInt(seccion.getAttribute('data-dias-max'), 10) || 5;
    var fMin = sumarHabiles(diasMin);
    var fMax = sumarHabiles(diasMax);

    var elMin = seccion.querySelector('[data-fecha-min]');
    var elMax = seccion.querySelector('[data-fecha-max]');
    if (elMin) elMin.textContent = fmtFecha(fMin);
    if (elMax) elMax.textContent = fmtFecha(fMax);

    var p1 = seccion.querySelector('[data-fecha-paso1]');
    var p2 = seccion.querySelector('[data-fecha-paso2]');
    var p3 = seccion.querySelector('[data-fecha-paso3]');
    if (p1) p1.textContent = 'Hoy';
    if (p2) p2.textContent = fmtFecha(sumarHabiles(1));
    if (p3) p3.textContent = fmtFecha(fMin) + ' - ' + fmtFecha(fMax);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-video-vitrina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.vitrinaIniciado) return;
    window.vitrinaIniciado = true;

    function iniciarAnimaciones() {
      var secciones = document.querySelectorAll('.vitrina-seccion[data-animacion="true"]');
      if (!secciones.length) return;

      if (!('IntersectionObserver' in window)) {
        secciones.forEach(function (s) { s.classList.add('vitrina-anim-on', 'vitrina-visible'); });
        return;
      }

      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('vitrina-visible');
            observador.unobserve(entrada.target);
          }
        });
      }, { threshold: 0.2 });

      secciones.forEach(function (s) {
        s.classList.add('vitrina-anim-on');
        observador.observe(s);
      });
    }

    function actualizarContador() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          var contadores = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble span[aria-hidden="true"]');
          contadores.forEach(function (el) { el.textContent = carrito.item_count; });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('.vitrina-boton[data-variante]');
      if (!boton) return;

      evento.preventDefault();

      var seccion = boton.closest('.vitrina-seccion');
      var accion = seccion ? seccion.getAttribute('data-accion-agregar') : 'confirmacion';
      var variante = boton.getAttribute('data-variante');
      var textoOriginal = boton.getAttribute('data-texto-original') || boton.textContent;

      if (boton.dataset.cargando === 'true') return;
      boton.dataset.cargando = 'true';
      boton.textContent = 'A√±adiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variante, quantity: 1 })
      })
        .then(function (respuesta) {
          if (!respuesta.ok) throw new Error('add-error');
          return respuesta.json();
        })
        .then(function () {
          if (accion === 'carrito') {
            window.location.href = '/cart';
            return;
          }
          boton.dataset.cargando = 'false';
          boton.classList.add('vitrina-boton--anadido');
          boton.textContent = 'A√±adido ‚úì';
          actualizarContador();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            boton.classList.remove('vitrina-boton--anadido');
            boton.textContent = textoOriginal;
          }, 1800);
        })
        .catch(function () {
          boton.dataset.cargando = 'false';
          boton.textContent = textoOriginal;
        });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarAnimaciones);
    } else {
      iniciarAnimaciones();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-popup10"] && !Shopify.designMode) return;
  try {
    
(function () {
  var K_SUSCRITO = 'popdesc_suscrito';
  var K_CERRADO = 'popdesc_cerrado';
  var K_PESTANA = 'popdesc_pestana_off';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function leer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function guardar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function iniciar(raiz) {
    if (raiz.dataset.popdescInit === 'true') { return; }
    raiz.dataset.popdescInit = 'true';

    var seccionId = raiz.getAttribute('data-seccion-id');
    var caja = raiz.querySelector('.popdesc__caja');
    var form = raiz.querySelector('.popdesc__form');
    var input = raiz.querySelector('[data-popdesc-input]');
    var errorEl = raiz.querySelector('[data-popdesc-error]');
    var btnEnviar = raiz.querySelector('[data-popdesc-enviar]');
    var btnEnviarTxt = raiz.querySelector('[data-popdesc-enviar-txt]');
    var vistaForm = raiz.querySelector('[data-popdesc-vista="form"]');
    var vistaOk = raiz.querySelector('[data-popdesc-vista="ok"]');
    var pestana = raiz.querySelector('[data-popdesc-pestana]');
    var btnCopiar = raiz.querySelector('[data-popdesc-copiar]');

    var codigo = raiz.getAttribute('data-codigo') || '';
    var retraso = (parseInt(raiz.getAttribute('data-retraso'), 10) || 0) * 1000;
    var scrollPct = parseInt(raiz.getAttribute('data-scroll'), 10) || 0;
    var salida = raiz.getAttribute('data-salida') === 'true';
    var dias = parseInt(raiz.getAttribute('data-dias'), 10) || 7;
    var enMovil = raiz.getAttribute('data-movil') === 'true';
    var enEscritorio = raiz.getAttribute('data-escritorio') === 'true';
    var autoaplicar = raiz.getAttribute('data-autoaplicar') === 'true';
    var disenio = !!(window.Shopify && window.Shopify.designMode);

    var textos = {};
    raiz.querySelectorAll('[data-popdesc-t]').forEach(function (el) { textos[el.getAttribute('data-popdesc-t')] = el.textContent.trim(); });
    var textoBoton = btnEnviarTxt ? btnEnviarTxt.textContent : '';
    var textoCopiar = btnCopiar ? btnCopiar.textContent : '';

    var abierta = false;
    var disparado = false;
    var ultimoFoco = null;
    var temporizador = null;

    function esMovil() { return !window.matchMedia('(min-width: 749px)').matches; }
    function permitido() { return esMovil() ? enMovil : enEscritorio; }
    function reciente(k) {
      var t = parseInt(leer(k), 10);
      return !!t && (Date.now() - t) < dias * 86400000;
    }
    function suscrito() { return leer(K_SUSCRITO) === '1'; }
    function puedeAbrir() {
      return !disenio && !disparado && !abierta && !suscrito() && !reciente(K_CERRADO) && permitido() && !document.documentElement.classList.contains('popdesc-bloqueo');
    }

    function mostrarVista(v) {
      if (vistaForm) { vistaForm.hidden = v !== 'form'; }
      if (vistaOk) { vistaOk.hidden = v !== 'ok'; }
    }

    function mostrarPestana() {
      if (!pestana || disenio || suscrito() || reciente(K_PESTANA) || !permitido()) { return; }
      pestana.hidden = false;
    }
    function ocultarPestana() { if (pestana) { pestana.hidden = true; } }

    function quitarDisparadores() {
      if (temporizador) { clearTimeout(temporizador); temporizador = null; }
      window.removeEventListener('scroll', alScroll);
      document.removeEventListener('mouseout', alSalir);
    }

    function abrir(vista) {
      if (abierta) { return; }
      abierta = true;
      disparado = true;
      quitarDisparadores();
      ultimoFoco = document.activeElement;
      mostrarVista(vista || 'form');
      ocultarPestana();
      raiz.classList.add('popdesc--abierta');
      document.documentElement.classList.add('popdesc-bloqueo');
      setTimeout(function () {
        if (!abierta) { return; }
        if (vista !== 'ok' && input && !esMovil()) { input.focus({ preventScroll: true }); }
        else if (caja) { caja.focus({ preventScroll: true }); }
      }, 380);
    }

    function cerrar() {
      if (!abierta) { return; }
      abierta = false;
      raiz.classList.remove('popdesc--abierta');
      document.documentElement.classList.remove('popdesc-bloqueo');
      if (!disenio && !suscrito()) {
        guardar(K_CERRADO, String(Date.now()));
        setTimeout(mostrarPestana, 450);
      }
      if (ultimoFoco && ultimoFoco.focus) { try { ultimoFoco.focus({ preventScroll: true }); } catch (e) {} }
    }

    function alScroll() {
      var doc = document.documentElement;
      var recorrido = doc.scrollHeight - window.innerHeight;
      if (recorrido <= 0) { return; }
      if ((window.scrollY / recorrido) * 100 >= scrollPct && puedeAbrir()) { abrir('form'); }
    }

    function alSalir(e) {
      if (esMovil() || e.relatedTarget || e.clientY > 0) { return; }
      if (puedeAbrir()) { abrir('form'); }
    }

    function aplicarDescuento() {
      if (!autoaplicar || !codigo) { return; }
      fetch('/discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).catch(function () {});
    }

    function exito() {
      guardar(K_SUSCRITO, '1');
      aplicarDescuento();
      ocultarPestana();
      if (abierta) { mostrarVista('ok'); } else { abrir('ok'); }
      document.dispatchEvent(new CustomEvent('popdesc:suscrito', { detail: { codigo: codigo } }));
    }

    function mostrarError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      if (input) { input.classList.add('popdesc__input--error'); }
    }
    function limpiarError() {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (input) { input.classList.remove('popdesc__input--error'); }
    }
    function estadoEnviando() {
      if (!btnEnviar) { return; }
      btnEnviar.classList.add('popdesc__boton--enviando');
      btnEnviar.setAttribute('aria-busy', 'true');
      if (btnEnviarTxt) { btnEnviarTxt.textContent = textos.enviando || textoBoton; }
    }

    function limpiarUrl() {
      if (!window.history || !window.history.replaceState) { return; }
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(null, '', url.pathname + url.search);
      } catch (e) {}
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var correo = input ? input.value.trim() : '';
        if (!EMAIL.test(correo)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          mostrarError(textos.invalido || '');
          if (input) { input.focus(); }
          return;
        }
        if (input) { input.value = correo; }
        limpiarError();
        estadoEnviando();
      });
    }

    if (input) { input.addEventListener('input', limpiarError); }

    if (btnCopiar) {
      btnCopiar.addEventListener('click', function () {
        var listo = function () {
          btnCopiar.textContent = textos.copiado || textoCopiar;
          setTimeout(function () { btnCopiar.textContent = textoCopiar; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(listo).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = codigo;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); listo(); } catch (err) {}
          document.body.removeChild(t);
        }
      });
    }

    raiz.querySelectorAll('[data-popdesc-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });

    document.addEventListener('keydown', function (e) {
      if (!abierta) { return; }
      if (e.key === 'Escape') { cerrar(); return; }
      if (e.key === 'Tab' && caja) {
        var focos = Array.prototype.filter.call(
          caja.querySelectorAll('button, input, a[href]'),
          function (el) { return !el.disabled && el.offsetParent !== null; }
        );
        if (!focos.length) { return; }
        var primero = focos[0];
        var ultimo = focos[focos.length - 1];
        if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
        else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
      }
    });

    if (pestana) {
      var btnPestana = pestana.querySelector('[data-popdesc-pestana-abrir]');
      var xPestana = pestana.querySelector('[data-popdesc-pestana-x]');
      if (btnPestana) { btnPestana.addEventListener('click', function () { abrir('form'); }); }
      if (xPestana) { xPestana.addEventListener('click', function () { guardar(K_PESTANA, String(Date.now())); ocultarPestana(); }); }
    }

    document.addEventListener('click', function (e) {
      var gatillo = e.target.closest('[data-popdesc-abrir], a[href="#descuento"]');
      if (!gatillo) { return; }
      e.preventDefault();
      abrir(suscrito() ? 'ok' : 'form');
    });

    if (disenio) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === seccionId) { abrir('form'); }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === seccionId) { cerrar(); }
      });
      return;
    }

    if (raiz.querySelector('[data-popdesc-posteado]')) { limpiarUrl(); exito(); return; }
    if (raiz.querySelector('[data-popdesc-con-error]')) {
      limpiarUrl();
      if (input) { input.classList.add('popdesc__input--error'); }
      abrir('form');
      return;
    }
    if (suscrito()) { return; }
    if (reciente(K_CERRADO)) { mostrarPestana(); return; }

    temporizador = setTimeout(function () { if (puedeAbrir()) { abrir('form'); } }, retraso);
    if (scrollPct > 0) { window.addEventListener('scroll', alScroll, { passive: true }); }
    if (salida) { document.addEventListener('mouseout', alSalir); }
  }

  function todo() { document.querySelectorAll('[data-popdesc]').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
  document.addEventListener('shopify:section:unload', function () { document.documentElement.classList.remove('popdesc-bloqueo'); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stn-landingtarjeteros"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatearDinero(centavos, formato) {
    formato = formato || '${{amount}}';
    var mk = /\{\{\s*(\w+)\s*\}\}/;
    function sep(n, p, m, d) {
      p = p == null ? 2 : p; m = m == null ? ',' : m; d = d == null ? '.' : d;
      if (isNaN(n) || n == null) { return '0'; }
      n = (n / 100).toFixed(p);
      var pp = n.split('.');
      return pp[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + m) + (pp[1] ? d + pp[1] : '');
    }
    var mm = formato.match(mk), val;
    switch (mm ? mm[1] : '') {
      case 'amount_no_decimals': val = sep(centavos, 0); break;
      case 'amount_with_comma_separator': val = sep(centavos, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = sep(centavos, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': val = sep(centavos, 0, ' ', ''); break;
      case 'amount_with_space_separator': val = sep(centavos, 2, ' ', ','); break;
      default: val = sep(centavos, 2);
    }
    return formato.replace(mk, val);
  }

  function iniciar(sec) {
    if (sec.dataset.ltjInit === 'true') { return; }
    sec.dataset.ltjInit = 'true';

    var formato = sec.getAttribute('data-formato-dinero') || '${{amount}}';
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var textos = {
      agregando: sec.getAttribute('data-txt-agregando') || 'Agregando...',
      error: sec.getAttribute('data-txt-error') || 'Intenta de nuevo',
      ahorras: sec.getAttribute('data-txt-ahorras') || 'Ahorras',
      unidad: sec.getAttribute('data-txt-unidad') || 'Unidad'
    };
    var precios = {
      1: (parseInt(sec.getAttribute('data-p1'), 10) || 0) * 100,
      2: (parseInt(sec.getAttribute('data-p2'), 10) || 0) * 100,
      3: (parseInt(sec.getAttribute('data-p3'), 10) || 0) * 100
    };
    var descuentos = {
      1: sec.getAttribute('data-desc-1') || '',
      2: sec.getAttribute('data-desc-2') || '',
      3: sec.getAttribute('data-desc-3') || ''
    };
    var unitario = precios[1];
    var accion = sec.getAttribute('data-accion') || 'checkout';
    var codLimpiarCarrito = sec.getAttribute('data-cod-limpiar-carrito') !== 'false';

    var datos = sec.querySelector('[data-ltj-variantes]');
    var variantes = [];
    if (datos) { try { variantes = JSON.parse(datos.textContent) || []; } catch (e) {} }
    var primeraDisp = null;
    for (var iv = 0; iv < variantes.length; iv++) { if (variantes[iv].available) { primeraDisp = variantes[iv]; break; } }
    if (!primeraDisp) { primeraDisp = variantes[0] || null; }

    var cantidad = 2;
    var colores = [];

    var slides = sec.querySelectorAll('[data-ltj-slide]');
    var puntos = sec.querySelectorAll('[data-ltj-punto]');
    var minis = sec.querySelectorAll('[data-ltj-miniatura]');
    var total = slides.length;
    var idx = 0;
    var timer = null;
    var auto = sec.getAttribute('data-gal-auto') !== 'false';
    var intervalo = (parseInt(sec.getAttribute('data-gal-intervalo'), 10) || 5) * 1000;

    function irA(n) {
      if (total < 2) { return; }
      idx = ((n % total) + total) % total;
      for (var i = 0; i < total; i++) { slides[i].classList.toggle('ltj__slide--activo', i === idx); }
      for (var j = 0; j < puntos.length; j++) { puntos[j].classList.toggle('ltj__punto--activo', j === idx); }
      for (var k = 0; k < minis.length; k++) {
        minis[k].classList.toggle('ltj__miniatura--activo', k === idx);
        if (k === idx) { minis[k].scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      }
    }
    function arrancar() { if (!auto || total < 2 || reducido || timer) { return; } timer = window.setInterval(function () { irA(idx + 1); }, intervalo); }
    function parar() { if (timer) { window.clearInterval(timer); timer = null; } }
    function reiniciar() { parar(); arrancar(); }

    for (var dp = 0; dp < puntos.length; dp++) {
      (function (b) { b.addEventListener('click', function () { irA(parseInt(b.getAttribute('data-ltj-punto'), 10)); reiniciar(); }); })(puntos[dp]);
    }
    for (var dm = 0; dm < minis.length; dm++) {
      (function (b) { b.addEventListener('click', function () { irA(parseInt(b.getAttribute('data-ltj-miniatura'), 10)); reiniciar(); }); })(minis[dm]);
    }
    var btnPrev = sec.querySelector('[data-ltj-prev]');
    var btnNext = sec.querySelector('[data-ltj-next]');
    if (btnPrev) { btnPrev.addEventListener('click', function () { irA(idx - 1); reiniciar(); }); }
    if (btnNext) { btnNext.addEventListener('click', function () { irA(idx + 1); reiniciar(); }); }

    var galeria = sec.querySelector('[data-ltj-galeria]');
    if (galeria && total > 1) {
      galeria.addEventListener('mouseenter', parar);
      galeria.addEventListener('mouseleave', arrancar);
      var tx = null, ty = null, movido = false;
      galeria.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; movido = false; parar(); }, { passive: true });
      galeria.addEventListener('touchmove', function (e) {
        if (tx === null) { return; }
        var dx = Math.abs(e.touches[0].clientX - tx);
        var dy = Math.abs(e.touches[0].clientY - ty);
        if (dx > 12 && dx > dy) { movido = true; }
      }, { passive: true });
      galeria.addEventListener('touchend', function (e) {
        if (tx === null) { return; }
        var dx = e.changedTouches[0].clientX - tx;
        if (movido && Math.abs(dx) > 40) { irA(dx < 0 ? idx + 1 : idx - 1); }
        tx = null;
        arrancar();
      });
    }
    arrancar();

    var resenas = sec.querySelectorAll('[data-ltj-resena]');
    if (resenas.length > 1 && !reducido) {
      var ri = 0;
      window.setInterval(function () {
        resenas[ri].classList.remove('ltj__resena--activo');
        ri = (ri + 1) % resenas.length;
        resenas[ri].classList.add('ltj__resena--activo');
      }, 4500);
    }

    var entrega = sec.querySelector('[data-ltj-entrega]');
    if (entrega) {
      var diasPaso = parseInt(entrega.getAttribute('data-dias-paso'), 10) || 3;
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      var sumarHabiles = function (base, dias) {
        var d = new Date(base.getTime());
        var s = 0;
        while (s < dias) {
          d.setDate(d.getDate() + 1);
          var dow = d.getDay();
          if (dow !== 0 && dow !== 6) { s += 1; }
        }
        return d;
      };
      var largo = function (d) { return d.getDate() + ' de ' + ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'][d.getMonth()]; };
      var corto = function (d) { return meses[d.getMonth()] + ' ' + d.getDate(); };
      var hoy = new Date();
      var fProceso = sumarHabiles(hoy, diasPaso);
      var fEntrega = sumarHabiles(hoy, diasPaso * 2);
      var elIni = sec.querySelector('[data-ltj-fecha-ini]');
      var elFin = sec.querySelector('[data-ltj-fecha-fin]');
      if (elIni) { elIni.textContent = largo(fProceso); }
      if (elFin) { elFin.textContent = largo(fEntrega); }
      var t1 = sec.querySelector('[data-ltj-tl-1]');
      var t2 = sec.querySelector('[data-ltj-tl-2]');
      var t3 = sec.querySelector('[data-ltj-tl-3]');
      if (t1) { t1.textContent = corto(hoy); }
      if (t2) { t2.textContent = corto(hoy) + ' - ' + corto(fProceso); }
      if (t3) { t3.textContent = corto(fProceso) + ' - ' + corto(fEntrega); }
    }

    var ah2 = sec.querySelector('[data-ltj-ahorro-2]');
    var ah3 = sec.querySelector('[data-ltj-ahorro-3]');
    var un2 = sec.querySelector('[data-ltj-unitario-2]');
    var un3 = sec.querySelector('[data-ltj-unitario-3]');
    if (ah2) { var d2 = unitario * 2 - precios[2]; if (d2 > 0) { ah2.textContent = textos.ahorras + ' ' + formatearDinero(d2, formato); } }
    if (ah3) { var d3 = unitario * 3 - precios[3]; if (d3 > 0) { ah3.textContent = textos.ahorras + ' ' + formatearDinero(d3, formato); } }
    if (un2 && precios[2]) { un2.textContent = formatearDinero(Math.round(precios[2] / 2), formato) + ' c/u'; }
    if (un3 && precios[3]) { un3.textContent = formatearDinero(Math.round(precios[3] / 3), formato) + ' c/u'; }

    var contUnidades = sec.querySelector('[data-ltj-unidades]');
    var plantilla = sec.querySelector('[data-ltj-plantilla]');
    var barraFoto = sec.querySelector('[data-ltj-barra-foto]');

    function mostrarFotoDeVariante(vid) {
      if (!vid) { return; }
      for (var i = 0; i < total; i++) {
        if (parseInt(slides[i].getAttribute('data-vid'), 10) === vid) { irA(i); reiniciar(); return; }
      }
    }

    function construirUnidades() {
      if (!contUnidades || !plantilla) { return; }
      contUnidades.innerHTML = '';
      colores = [];
      for (var u = 0; u < cantidad; u++) {
        (function (i) {
          var nodo = plantilla.content.cloneNode(true);
          var unidad = nodo.querySelector('.ltj__unidad');
          var lbl = nodo.querySelector('.ltj__unidad-lbl');
          if (lbl) { lbl.textContent = textos.unidad + ' ' + (i + 1); }
          var muestras = unidad.querySelectorAll('.ltj__muestra');
          var primera = null;
          for (var m = 0; m < muestras.length; m++) {
            (function (sw) {
              if (sw.disabled) { return; }
              if (!primera) { primera = sw; }
              sw.addEventListener('click', function () {
                for (var x = 0; x < muestras.length; x++) { muestras[x].classList.remove('ltj__muestra--activo'); }
                sw.classList.add('ltj__muestra--activo');
                colores[i] = { color: sw.getAttribute('data-color'), vid: parseInt(sw.getAttribute('data-vid'), 10) };
                if (i === 0) {
                  mostrarFotoDeVariante(parseInt(sw.getAttribute('data-vid'), 10));
                  var img = sw.getAttribute('data-img');
                  if (barraFoto && img) { barraFoto.src = img; }
                }
              });
            })(muestras[m]);
          }
          if (primera) {
            primera.classList.add('ltj__muestra--activo');
            colores[i] = { color: primera.getAttribute('data-color'), vid: parseInt(primera.getAttribute('data-vid'), 10) };
          }
          contUnidades.appendChild(unidad);
        })(u);
      }
    }

    var ctaPrecios = sec.querySelectorAll('[data-ltj-cta-precio]');
    var barraPrecio = sec.querySelector('[data-ltj-barra-precio]');
    var barraSub = sec.querySelector('[data-ltj-barra-sub]');
    var subBase = barraSub ? barraSub.textContent : '';

    function pintarPrecio() {
      var actual = precios[cantidad];
      var antes = unitario * cantidad;
      var html = formatearDinero(actual, formato);
      if (antes > actual) { html += ' <s>' + formatearDinero(antes, formato) + '</s>'; }
      for (var i = 0; i < ctaPrecios.length; i++) { ctaPrecios[i].innerHTML = html; }
      if (barraPrecio) { barraPrecio.textContent = formatearDinero(actual, formato); }
      if (barraSub) { barraSub.textContent = cantidad + (cantidad === 1 ? ' unidad ¬∑ ' : ' unidades ¬∑ ') + subBase; }
    }

    var packs = sec.querySelectorAll('[data-ltj-pack]');
    for (var pk = 0; pk < packs.length; pk++) {
      (function (b) {
        b.addEventListener('click', function () {
          for (var x = 0; x < packs.length; x++) {
            packs[x].classList.remove('ltj__pack--activo');
            packs[x].setAttribute('aria-checked', 'false');
          }
          b.classList.add('ltj__pack--activo');
          b.setAttribute('aria-checked', 'true');
          cantidad = parseInt(b.getAttribute('data-ltj-pack'), 10) || 1;
          construirUnidades();
          pintarPrecio();
        });
      })(packs[pk]);
    }

    construirUnidades();
    pintarPrecio();

    var viendo = sec.querySelector('[data-ltj-viendo]');
    var viendoNum = sec.querySelector('[data-ltj-viendo-num]');
    if (viendo && viendoNum) {
      var vMin = parseInt(sec.getAttribute('data-viendo-min'), 10) || 8;
      var vMax = parseInt(sec.getAttribute('data-viendo-max'), 10) || 27;
      var actualV = vMin + Math.floor(Math.random() * (vMax - vMin + 1));
      viendoNum.textContent = actualV;
      viendo.hidden = false;
      window.setInterval(function () {
        actualV += (Math.random() < 0.5 ? -1 : 1);
        if (actualV < vMin) { actualV = vMin; }
        if (actualV > vMax) { actualV = vMax; }
        viendoNum.textContent = actualV;
      }, 22000 + Math.floor(Math.random() * 16000));
    }

    var riel = sec.querySelector('[data-ltj-opiniones]');
    if (riel) {
      var oPrev = sec.querySelector('[data-ltj-opi-prev]');
      var oNext = sec.querySelector('[data-ltj-opi-next]');
      var paso = function () { var c = riel.querySelector('.ltj__opinion'); return c ? c.offsetWidth + 14 : 300; };
      if (oPrev) { oPrev.addEventListener('click', function () { riel.scrollBy({ left: -paso(), behavior: 'smooth' }); }); }
      if (oNext) { oNext.addEventListener('click', function () { riel.scrollBy({ left: paso(), behavior: 'smooth' }); }); }
    }

    var faqs = sec.querySelectorAll('[data-ltj-faq]');
    for (var f = 0; f < faqs.length; f++) {
      (function (btn) {
        var panel = btn.nextElementSibling;
        btn.addEventListener('click', function () {
          var abierto = btn.getAttribute('aria-expanded') === 'true';
          for (var g = 0; g < faqs.length; g++) {
            faqs[g].setAttribute('aria-expanded', 'false');
            if (faqs[g].nextElementSibling) { faqs[g].nextElementSibling.style.maxHeight = null; }
          }
          if (!abierto && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      })(faqs[f]);
    }

    var barra = sec.querySelector('[data-ltj-barra]');
    var ancla = sec.querySelector('.ltj__packs');
    if (barra && ancla && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (ents) {
        for (var e = 0; e < ents.length; e++) { barra.hidden = ents[e].isIntersecting; }
      }, { threshold: 0 });
      obs.observe(ancla);
    }

    var lupa = sec.querySelector('[data-ltj-lupa]');
    var lupaImg = sec.querySelector('[data-ltj-lupa-img]');
    if (lupa && lupaImg) {
      var grupoActivo = [];
      var lupaIdx = 0;
      var pintarLupa = function () {
        var el = grupoActivo[lupaIdx];
        if (!el) { return; }
        lupaImg.src = el.getAttribute('data-ltj-full') || el.currentSrc || el.src;
        lupaImg.alt = el.alt || '';
      };
      var abrirLupa = function (el) {
        var grupo = el.getAttribute('data-ltj-grupo') || 'general';
        grupoActivo = Array.prototype.slice.call(sec.querySelectorAll('[data-ltj-zoom][data-ltj-grupo="' + grupo + '"]'));
        lupaIdx = Math.max(0, grupoActivo.indexOf(el));
        pintarLupa();
        lupa.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      };
      var cerrarLupa = function () {
        lupa.hidden = true;
        lupaImg.src = '';
        document.documentElement.style.overflow = '';
      };
      var zooms = sec.querySelectorAll('[data-ltj-zoom]');
      for (var z = 0; z < zooms.length; z++) {
        (function (el) {
          el.addEventListener('click', function (ev) { ev.preventDefault(); abrirLupa(el); });
        })(zooms[z]);
      }
      var lupaCerrar = sec.querySelector('[data-ltj-lupa-cerrar]');
      var lupaPrev = sec.querySelector('[data-ltj-lupa-prev]');
      var lupaNext = sec.querySelector('[data-ltj-lupa-next]');
      if (lupaCerrar) { lupaCerrar.addEventListener('click', cerrarLupa); }
      lupa.addEventListener('click', function (ev) { if (ev.target === lupa) { cerrarLupa(); } });
      if (lupaPrev) { lupaPrev.addEventListener('click', function () { lupaIdx = (lupaIdx - 1 + grupoActivo.length) % grupoActivo.length; pintarLupa(); }); }
      if (lupaNext) { lupaNext.addEventListener('click', function () { lupaIdx = (lupaIdx + 1) % grupoActivo.length; pintarLupa(); }); }
      document.addEventListener('keydown', function (ev) {
        if (lupa.hidden) { return; }
        if (ev.key === 'Escape') { cerrarLupa(); }
        if (ev.key === 'ArrowLeft' && lupaPrev) { lupaPrev.click(); }
        if (ev.key === 'ArrowRight' && lupaNext) { lupaNext.click(); }
      });
      var lsx = null;
      lupa.addEventListener('touchstart', function (ev) { lsx = ev.touches[0].clientX; }, { passive: true });
      lupa.addEventListener('touchend', function (ev) {
        if (lsx === null) { return; }
        var dx = ev.changedTouches[0].clientX - lsx;
        if (Math.abs(dx) > 45) { lupaIdx = (lupaIdx + (dx < 0 ? 1 : -1) + grupoActivo.length) % grupoActivo.length; pintarLupa(); }
        lsx = null;
      });
    }

    function construirItems() {
      var conteo = {};
      for (var i = 0; i < cantidad; i++) {
        var c = colores[i];
        var vid = (c && c.vid) ? c.vid : (primeraDisp ? primeraDisp.id : null);
        if (!vid) { continue; }
        conteo[vid] = (conteo[vid] || 0) + 1;
      }
      var items = [];
      var claves = Object.keys(conteo);
      for (var k = 0; k < claves.length; k++) { items.push({ id: parseInt(claves[k], 10), quantity: conteo[claves[k]] }); }
      return items;
    }

    var ctas = sec.querySelectorAll('[data-ltj-cta]');
    var codCtas = sec.querySelectorAll('[data-ltj-cod]');
    var agregando = false;
    var agregandoCod = false;

    function peticionJson(url, opciones) {
      return fetch(url, opciones).then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.json();
      });
    }

    function agregarItemsShopify(items, limpiarPrimero) {
      var inicio = Promise.resolve();
      if (limpiarPrimero) {
        inicio = peticionJson('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
      }
      return inicio.then(function () {
        return peticionJson('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      });
    }

    function redirigirConDescuento(destino, codigo) {
      if (codigo) {
        window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(destino);
      } else {
        window.location.href = destino;
      }
    }

    function bloquearBotones(lista, bloqueado) {
      for (var i = 0; i < lista.length; i++) {
        if (bloqueado) {
          lista[i].setAttribute('disabled', 'disabled');
          lista[i].setAttribute('aria-busy', 'true');
        } else {
          lista[i].removeAttribute('disabled');
          lista[i].removeAttribute('aria-busy');
        }
      }
    }

    function agregar() {
      if (agregando || agregandoCod) { return; }
      var items = construirItems();
      if (!items.length) { return; }

      agregando = true;
      var txts = sec.querySelectorAll('[data-ltj-cta-txt]');
      var origen = [];
      bloquearBotones(ctas, true);
      for (var t = 0; t < txts.length; t++) {
        origen[t] = txts[t].textContent;
        txts[t].textContent = textos.agregando;
      }

      agregarItemsShopify(items, false).then(function () {
        var codigo = descuentos[cantidad];
        if (accion === 'carrito') {
          redirigirConDescuento('/cart', codigo);
        } else {
          redirigirConDescuento('/checkout', codigo);
        }
      }).catch(function () {
        agregando = false;
        bloquearBotones(ctas, false);
        for (var t2 = 0; t2 < txts.length; t2++) { txts[t2].textContent = textos.error; }
        window.setTimeout(function () {
          for (var t3 = 0; t3 < txts.length; t3++) { txts[t3].textContent = origen[t3] || ''; }
        }, 2200);
      });
    }
    for (var cb = 0; cb < ctas.length; cb++) { ctas[cb].addEventListener('click', agregar); }

    function agregarContraEntrega() {
      if (agregando || agregandoCod) { return; }
      var items = construirItems();
      if (!items.length) { return; }

      agregandoCod = true;
      bloquearBotones(codCtas, true);
      bloquearBotones(ctas, true);

      var titulosCod = sec.querySelectorAll('[data-ltj-cod] .ltj__cod-txt b, [data-ltj-cod] .ltj__cta-txt');
      var textosCodOriginales = [];
      for (var i = 0; i < titulosCod.length; i++) {
        textosCodOriginales[i] = titulosCod[i].textContent;
        titulosCod[i].textContent = textos.agregando;
      }

      agregarItemsShopify(items, codLimpiarCarrito).then(function () {
        var codigo = descuentos[cantidad];
        /*
          Releasit procesa de forma estable los productos reales del carrito.
          El parametro streetnova_cod permite identificar que el usuario viene
          desde esta landing. En /cart debe estar habilitado el boton COD de Releasit.
        */
        redirigirConDescuento('/cart?streetnova_cod=1', codigo);
      }).catch(function () {
        agregandoCod = false;
        bloquearBotones(codCtas, false);
        bloquearBotones(ctas, false);
        for (var j = 0; j < titulosCod.length; j++) { titulosCod[j].textContent = textos.error; }
        window.setTimeout(function () {
          for (var k = 0; k < titulosCod.length; k++) { titulosCod[k].textContent = textosCodOriginales[k] || ''; }
        }, 2200);
      });
    }
    for (var cc = 0; cc < codCtas.length; cc++) { codCtas[cc].addEventListener('click', agregarContraEntrega); }

    var crossBtns = sec.querySelectorAll('[data-ltj-cross-add]');
    for (var cr = 0; cr < crossBtns.length; cr++) {
      (function (boton) {
        boton.addEventListener('click', function () {
          var vid = parseInt(boton.getAttribute('data-vid'), 10);
          if (!vid) { return; }
          var previo = boton.textContent;
          boton.setAttribute('disabled', 'disabled');
          boton.textContent = textos.agregando;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          }).then(function (r) {
            if (!r.ok) { throw new Error('error'); }
            return r.json();
          }).then(function () {
            boton.textContent = 'Agregado';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function () { boton.removeAttribute('disabled'); boton.textContent = previo; }, 1800);
          }).catch(function () {
            boton.removeAttribute('disabled');
            boton.textContent = previo;
          });
        });
      })(crossBtns[cr]);
    }

    var videosReales = sec.querySelectorAll('[data-ltj-video]');
    if (videosReales.length && 'IntersectionObserver' in window) {
      var vObs = new IntersectionObserver(function (ents) {
        for (var i = 0; i < ents.length; i++) {
          var v = ents[i].target;
          if (ents[i].isIntersecting) { var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); } }
          else { v.pause(); }
        }
      }, { threshold: 0.25 });
      for (var vv = 0; vv < videosReales.length; vv++) { vObs.observe(videosReales[vv]); }
    }

    var compra = sec.querySelector('.ltj__compra');
    function ajustarSticky() {
      if (!compra) { return; }
      if (window.innerWidth < 990) { compra.style.top = ''; return; }
      var margen = 20;
      var alto = compra.offsetHeight;
      var disponible = window.innerHeight - margen;
      if (alto <= disponible) {
        compra.style.top = margen + 'px';
      } else {
        compra.style.top = (window.innerHeight - alto - margen) + 'px';
      }
    }
    ajustarSticky();
    window.addEventListener('resize', ajustarSticky);
    window.addEventListener('load', ajustarSticky);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(ajustarSticky); }
  }

  function todo() {
    var secs = document.querySelectorAll('[data-ltj]');
    for (var i = 0; i < secs.length; i++) { iniciar(secs[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrina-producto-flotante"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(sec) {
    if (sec.dataset.vtInit === 'true') { return; }
    sec.dataset.vtInit = 'true';

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conPuntero = window.matchMedia('(hover: hover)').matches;

    var escena = sec.querySelector('[data-vt-escena]');
    var slides = sec.querySelectorAll('[data-vt-slide]');
    var fichas = sec.querySelectorAll('[data-vt-ficha]');
    var puntos = sec.querySelectorAll('[data-vt-punto]');
    var total = slides.length;
    var idx = 0;

    function ir(n) {
      if (total < 2) { return; }
      idx = (n + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('vt__slide--activo', i === idx); });
      fichas.forEach(function (f, i) { f.classList.toggle('vt__ficha--activa', i === idx); });
      puntos.forEach(function (p, i) { p.classList.toggle('vt__punto--activo', i === idx); });
    }

    var prev = sec.querySelector('[data-vt-prev]');
    var next = sec.querySelector('[data-vt-next]');
    if (prev) { prev.addEventListener('click', function () { ir(idx - 1); reiniciar(); }); }
    if (next) { next.addEventListener('click', function () { ir(idx + 1); reiniciar(); }); }
    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        ir(parseInt(p.getAttribute('data-vt-punto'), 10));
        reiniciar();
      });
    });

    var timer = null;
    var auto = sec.getAttribute('data-auto') === 'true';
    var intervalo = (parseInt(sec.getAttribute('data-intervalo'), 10) || 6) * 1000;

    function arrancar() {
      if (!auto || total < 2 || reducido) { return; }
      timer = setInterval(function () { ir(idx + 1); }, intervalo);
    }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function reiniciar() { parar(); arrancar(); }

    if (escena) {
      escena.addEventListener('mouseenter', parar);
      escena.addEventListener('mouseleave', arrancar);
      escena.addEventListener('focusin', parar);
    }
    arrancar();

    if (escena && total > 1) {
      var sx = null;
      escena.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; parar(); }, { passive: true });
      escena.addEventListener('touchend', function (e) {
        if (sx === null) { return; }
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { ir(dx < 0 ? idx + 1 : idx - 1); }
        sx = null;
        arrancar();
      });
    }

    var activo = sec.getAttribute('data-parallax') === 'true';
    if (escena && activo && conPuntero && !reducido) {
      var pendiente = false;
      var rx = 0, ry = 0;

      function pintar() {
        var t = sec.querySelector('.vt__slide--activo [data-vt-tilt]');
        if (t) { t.style.transform = 'rotateY(' + rx + 'deg) rotateX(' + ry + 'deg)'; }
        pendiente = false;
      }

      escena.addEventListener('mousemove', function (e) {
        var r = escena.getBoundingClientRect();
        rx = ((e.clientX - r.left) / r.width - 0.5) * 22;
        ry = (0.5 - (e.clientY - r.top) / r.height) * 14;
        if (!pendiente) { pendiente = true; window.requestAnimationFrame(pintar); }
      });

      escena.addEventListener('mouseleave', function () {
        sec.querySelectorAll('[data-vt-tilt]').forEach(function (t) { t.style.transform = ''; });
      });
    }

    sec.querySelectorAll('[data-vt-comprar]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var id = boton.getAttribute('data-id');
        if (!id) { return; }
        var txt = boton.querySelector('[data-vt-comprar-txt]');
        boton.setAttribute('disabled', 'disabled');
        if (txt) { txt.textContent = 'Un momento...'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) { throw new Error('no'); }
          window.location.href = '/checkout';
        }).catch(function () {
          boton.removeAttribute('disabled');
          if (txt) { txt.textContent = 'Reintentar'; }
        });
      });
    });
  }

  function todo() { document.querySelectorAll('.vt').forEach(iniciar); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); } else { todo(); }
  document.addEventListener('shopify:section:load', todo);
})();

  } catch(e) { console.error(e); }
})();
})();
